/**
 * =================================================================
 * Talia Sari Jewelry Customizer - Refactored Code
 * =================================================================
 * Description: This script handles the interactive jewelry customizer,
 * including map integration, product variant selection, and UI updates.
 *
 * Author: Pradhuman (Refactored from original)
 * Version: 2.0.0
 * Last Updated: 15-09-2025
 * =================================================================
 */

// Wrap the entire script in a jQuery document ready function to ensure the DOM is loaded.
$(function () {

    // =================================================================
    // 1. CONSTANTS & CONFIGURATION
    // All Dynamic/static data and configuration options are stored here.
    // =================================================================

      const scriptTag = document.getElementById("map_animation_variables");
      let mapVars = {};
      if (scriptTag) {
        try {
          mapVars = JSON.parse(scriptTag.textContent);
        } catch (e) {
          console.error("MAP_JEWELRY: Error parsing map animation variables:", e);
        }
      }

      const map_variant_discounts_variables = document.getElementById("map_variant_discounts_variables");
      let map_variant_discounts_variables_content;
      if (map_variant_discounts_variables) {
        try {
          map_variant_discounts_variables_content = JSON.parse(map_variant_discounts_variables.textContent);
        } catch (e) {
          console.error("MAP_JEWELRY: Error parsing map discount variables:", e);
        }
      } 

    const CONSTANTS = {
         MAP_VARS: {
            map_easeTo: parseFloat(mapVars.map_easeTo) || 1,
            map_startZoom: parseFloat(mapVars.map_startZoom) || 5,
            map_zoom_animation: mapVars.map_zoom_animation,
            map_defaultZoom: parseFloat(mapVars.map_defaultZoom) || 13,
            map_zoomDuration: parseFloat(mapVars.map_zoomDuration) || 2000,
            map_zoominClickLeves: parseFloat(mapVars.map_zoominClickLeves) || 10,
          },
        STATIC_STYLE_SILVER: ["cknhuhrr401ie17ldf1hsycvv", "cknihmp0z0jih17ld0ef0omih", "cknihdca70jb317oahigb31xn", "cknihqu4l0f6v17p1bawu2fhf", "cknihtoad0jnc17qz4ogyd0co", "cknihvrto0jox17qza72evznm", "ckwgbhqzj05df15p29yc591zu"],
        STATIC_STYLE_GOLDEN: ["ckn7tzynx0d0h18pfy3z1blm5", "cknihl3ri0f2g17p1ahw4w1nn", "cknig4sy70ic517pdrzljiw8q", "cknig6cv20idm17qxitvbf0dc", "cknighyr10aee17ny32fl8tl4", "cknifzb9z0i7x17l4i1vtam56", "ckwgiv6if4yn714ocjvgwcj10"],
        LAYER_SETS: {
            gold: ["background", "water_gold", "parks_gold_1", "parks_gold_2", "designer_choice_gold_1", "designer_choice_gold_2", "designer_choice_gold_3", "streets_gold_1", "streets_gold_2", "streets_gold_3", "streets_gold_4", "streets_gold_5", "streets_gold_6", "streets_gold_7", "water_gold_outline"],
            silver: ["background", "water_silver", "parks_silver_1", "parks_silver_2", "designer_choice_silver_1", "designer_choice_silver_2", "designer_choice_silver_3", "streets_silver_1", "streets_silver_2", "streets_silver_3", "streets_silver_4", "streets_silver_5", "streets_silver_6", "streets_silver_7", "water_silver_outline"]
        },
        ALL_GOLD_LAYERS: [
            ["background", "designer_choice_gold_1", "designer_choice_gold_2", "designer_choice_gold_3", "streets_gold_1", "streets_gold_2", "streets_gold_3", "streets_gold_4", "streets_gold_5", "streets_gold_6", "streets_gold_7"], // 0
            ["background", "parks_gold_1", "parks_gold_2", "water_gold", "streets_gold_1", "streets_gold_2", "streets_gold_3", "streets_gold_4", "streets_gold_5", "streets_gold_6", "streets_gold_7"], // 1
            ["background", "water_gold", "streets_gold_1", "streets_gold_2", "streets_gold_3", "streets_gold_4", "streets_gold_5", "streets_gold_6", "streets_gold_7"], // 2
            ["background", "parks_gold_1", "parks_gold_2", "streets_gold_1", "streets_gold_2", "streets_gold_3", "streets_gold_4", "streets_gold_5", "streets_gold_6", "streets_gold_7"], // 3
            ["background", "streets_gold_1", "streets_gold_2", "streets_gold_3", "streets_gold_4", "streets_gold_5", "streets_gold_6", "streets_gold_7"], // 4
            ["background", "water_gold"], // 5
            ["background", "streets_gold_1", "streets_gold_2", "streets_gold_3", "streets_gold_4", "streets_gold_5", "streets_gold_6", "streets_gold_7", "water_gold_outline"] // 6
        ],
        ALL_SILVER_LAYERS: [
            ["background", "designer_choice_silver_1", "designer_choice_silver_2", "designer_choice_silver_3", "streets_silver_1", "streets_silver_2", "streets_silver_3", "streets_silver_4", "streets_silver_5", "streets_silver_6", "streets_silver_7"], // 0
            ["background", "parks_silver_1", "parks_silver_2", "water_silver", "streets_silver_1", "streets_silver_2", "streets_silver_3", "streets_silver_4", "streets_silver_5", "streets_silver_6", "streets_silver_7"], // 1
            ["background", "water_silver", "streets_silver_1", "streets_silver_2", "streets_silver_3", "streets_silver_4", "streets_silver_5", "streets_silver_6", "streets_silver_7"], // 2
            ["background", "parks_silver_1", "parks_silver_2", "streets_silver_1", "streets_silver_2", "streets_silver_3", "streets_silver_4", "streets_silver_5", "streets_silver_6", "streets_silver_7"], // 3
            ["background", "streets_silver_1", "streets_silver_2", "streets_silver_3", "streets_silver_4", "streets_silver_5", "streets_silver_6", "streets_silver_7"], // 4
            ["background", "water_silver"], // 5
            ["background", "streets_silver_1", "streets_silver_2", "streets_silver_3", "streets_silver_4", "streets_silver_5", "streets_silver_6", "streets_silver_7", "water_silver_outline"] // 6
        ],
        STYLE_NAMES: ["Designer choice (Recommended)", "Streets + Water + Parks", "Streets + Water", "Streets + Parks", "Streets only", "Water only", "Streets + Water Outline"],
        SHAPE_ARRAY: ["", "Square", "Circle", "Rectangle", "Oval", "Pear"],
        MAPBOX_ACCESS_TOKEN: 'pk.eyJ1IjoidGFsaWFzYXJpIiwiYSI6ImY4MzcwNjAyMDRjZGUyOTZmMjM0OGFlYmRhMmI4YjdjIn0.qfgdEmate5DzRnG1vZHOCw',
        DEFAULT_MAP_CENTER: [-73.9855, 40.7584],
        DEFAULT_MAP_ZOOM: parseFloat(mapVars.map_defaultZoom) || 13,
        VARIANT_DISCOUNT: map_variant_discounts_variables_content.BLOCKS_VARIANT_DISCOUNT,
        VARIANT_VISIBILITY: map_variant_discounts_variables_content.VARIANT_VISIBILITY,
        VARIANT_FROM_PRICE_VISIBILITY: map_variant_discounts_variables_content.VARIANT_FROM_PRICE_VISIBILITY,
        VARIANT_COMBINATIONS: [
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Gold Plated",
                  marker: "None",
                  variantSku: "CSTM_Necklace_Small_Plated_None",
                  prefix: "",
                  mapId: "GAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Gold Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Necklace_Small_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "GAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Gold Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Necklace_Small_Plated_Marker",
                  prefix: "D-",
                  mapId: "GAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Silver Plated",
                  marker: "None",
                  variantSku: "CSTM_Necklace_Small_Plated_None",
                  prefix: "",
                  mapId: "SAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Silver Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Necklace_Small_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "SAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Silver Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Necklace_Small_Plated_Marker",
                  prefix: "D-",
                  mapId: "SAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Sterling Silver",
                  marker: "None",
                  variantSku: "FCSTM_Necklace_Small_Sterling_None",
                  prefix: "",
                  mapId: "FSAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Sterling Silver",
                  marker: "Enamel",
                  variantSku: "FCSTM_Necklace_Small_Sterling_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FSAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Sterling Silver",
                  marker: "Marker",
                  variantSku: "FCSTM_Necklace_Small_Sterling_Marker",
                  prefix: "D-",
                  mapId: "FSAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Gold Vermeil",
                  marker: "None",
                  variantSku: "FCSTM_Necklace_Small_Vermeil_None",
                  prefix: "",
                  mapId: "FVAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Gold Vermeil",
                  marker: "Enamel",
                  variantSku: "FCSTM_Necklace_Small_Vermeil_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FVAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "Gold Vermeil",
                  marker: "Marker",
                  variantSku: "FCSTM_Necklace_Small_Vermeil_Marker",
                  prefix: "D-",
                  mapId: "FVAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "14K Yellow Gold",
                  marker: "None",
                  variantSku: "FCSTM_Necklace_Small_14K_None",
                  prefix: "",
                  mapId: "F14YAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "14K Yellow Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Necklace_Small_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14YAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "14K Yellow Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Necklace_Small_14K_Marker",
                  prefix: "D-",
                  mapId: "F14YAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "14K White Gold",
                  marker: "None",
                  variantSku: "FCSTM_Necklace_Small_14K_None",
                  prefix: "",
                  mapId: "F14WAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "14K White Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Necklace_Small_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14WAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Necklace",
                  shape: "Small",
                  materiel: "14K White Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Necklace_Small_14K_Marker",
                  prefix: "D-",
                  mapId: "F14WAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Gold Plated",
                  marker: "None",
                  variantSku: "CSTM_Necklace_Large_Plated_None",
                  prefix: "",
                  mapId: "GAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Gold Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Necklace_Large_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "GAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Gold Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Necklace_Large_Plated_Marker",
                  prefix: "D-",
                  mapId: "GAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Silver Plated",
                  marker: "None",
                  variantSku: "CSTM_Necklace_Large_Plated_None",
                  prefix: "",
                  mapId: "SAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Silver Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Necklace_Large_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "SAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Silver Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Necklace_Large_Plated_Marker",
                  prefix: "D-",
                  mapId: "SAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711790"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Sterling Silver",
                  marker: "None",
                  variantSku: "FCSTM_Necklace_Large_Sterling_None",
                  prefix: "",
                  mapId: "FSAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Sterling Silver",
                  marker: "Enamel",
                  variantSku: "FCSTM_Necklace_Large_Sterling_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FSAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Sterling Silver",
                  marker: "Marker",
                  variantSku: "FCSTM_Necklace_Large_Sterling_Marker",
                  prefix: "D-",
                  mapId: "FSAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Gold Vermeil",
                  marker: "None",
                  variantSku: "FCSTM_Necklace_Large_Vermeil_None",
                  prefix: "",
                  mapId: "FVAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Gold Vermeil",
                  marker: "Enamel",
                  variantSku: "FCSTM_Necklace_Large_Vermeil_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FVAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "Gold Vermeil",
                  marker: "Marker",
                  variantSku: "FCSTM_Necklace_Large_Vermeil_Marker",
                  prefix: "D-",
                  mapId: "FVAAAAAA",
                  suffix: "-45 / -50",
                  hs: "711311"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "14K Yellow Gold",
                  marker: "None",
                  variantSku: "FCSTM_Necklace_Large_14K_None",
                  prefix: "",
                  mapId: "F14YAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "14K Yellow Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Necklace_Large_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14YAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "14K Yellow Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Necklace_Large_14K_Marker",
                  prefix: "D-",
                  mapId: "F14YAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "14K White Gold",
                  marker: "None",
                  variantSku: "FCSTM_Necklace_Large_14K_None",
                  prefix: "",
                  mapId: "F14WAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "14K White Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Necklace_Large_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14WAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Necklace",
                  shape: "Large",
                  materiel: "14K White Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Necklace_Large_14K_Marker",
                  prefix: "D-",
                  mapId: "F14WAAAAA",
                  suffix: "-45 / -50",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Gold Plated",
                  marker: "None",
                  variantSku: "CSTM_Earrings_Large_Plated_None",
                  prefix: "",
                  mapId: "GAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Gold Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Earrings_Large_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "GAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Gold Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Earrings_Large_Plated_Marker",
                  prefix: "D-",
                  mapId: "GAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Silver Plated",
                  marker: "None",
                  variantSku: "CSTM_Earrings_Large_Plated_None",
                  prefix: "",
                  mapId: "SAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Silver Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Earrings_Large_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "SAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Silver Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Earrings_Large_Plated_Marker",
                  prefix: "D-",
                  mapId: "SAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Sterling Silver",
                  marker: "None",
                  variantSku: "FCSTM_Earrings_Large_Sterling_None",
                  prefix: "",
                  mapId: "FSAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Sterling Silver",
                  marker: "Enamel",
                  variantSku: "FCSTM_Earrings_Large_Sterling_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FSAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Sterling Silver",
                  marker: "Marker",
                  variantSku: "FCSTM_Earrings_Large_Sterling_Marker",
                  prefix: "D-",
                  mapId: "FSAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Gold Vermeil",
                  marker: "None",
                  variantSku: "FCSTM_Earrings_Large_Vermeil_None",
                  prefix: "",
                  mapId: "FVAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Gold Vermeil",
                  marker: "Enamel",
                  variantSku: "FCSTM_Earrings_Large_Vermeil_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FVAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "Gold Vermeil",
                  marker: "Marker",
                  variantSku: "FCSTM_Earrings_Large_Vermeil_Marker",
                  prefix: "D-",
                  mapId: "FVAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "14K Yellow Gold",
                  marker: "None",
                  variantSku: "FCSTM_Earrings_Large_14K_None",
                  prefix: "",
                  mapId: "F14YAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "14K Yellow Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Earrings_Large_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14YAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "14K Yellow Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Earrings_Large_14K_Marker",
                  prefix: "D-",
                  mapId: "F14YAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "14K White Gold",
                  marker: "None",
                  variantSku: "FCSTM_Earrings_Large_14K_None",
                  prefix: "",
                  mapId: "F14WAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "14K White Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Earrings_Large_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14WAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Large",
                  materiel: "14K White Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Earrings_Large_14K_Marker",
                  prefix: "D-",
                  mapId: "F14WAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Gold Plated",
                  marker: "None",
                  variantSku: "CSTM_Earrings_Small_Plated_None",
                  prefix: "",
                  mapId: "GAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Gold Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Earrings_Small_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "GAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Gold Plated",
                  marker: "Marker",
                  variantSku: "FCSTM_Earrings_Small_Plated_Marker",
                  prefix: "D-",
                  mapId: "GAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Silver Plated",
                  marker: "None",
                  variantSku: "CSTM_Earrings_Small_Plated_None",
                  prefix: "",
                  mapId: "SAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Silver Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Earrings_Small_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "SAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Silver Plated",
                  marker: "Marker",
                  variantSku: "FCSTM_Earrings_Small_Plated_Marker",
                  prefix: "D-",
                  mapId: "SAAAAAA",
                  suffix: "-2",
                  hs: "711790"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Sterling Silver",
                  marker: "None",
                  variantSku: "FCSTM_Earrings_Small_Sterling_None",
                  prefix: "",
                  mapId: "FSAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Sterling Silver",
                  marker: "Enamel",
                  variantSku: "FCSTM_Earrings_Small_Sterling_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FSAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Sterling Silver",
                  marker: "Marker",
                  variantSku: "FCSTM_Earrings_Small_Sterling_Marker",
                  prefix: "D-",
                  mapId: "FSAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Gold Vermeil",
                  marker: "None",
                  variantSku: "FCSTM_Earrings_Small_Vermeil_None",
                  prefix: "",
                  mapId: "FVAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Gold Vermeil",
                  marker: "Enamel",
                  variantSku: "FCSTM_Earrings_Small_Vermeil_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FVAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "Gold Vermeil",
                  marker: "Marker",
                  variantSku: "FCSTM_Earrings_Small_Vermeil_Marker",
                  prefix: "D-",
                  mapId: "FVAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "14K Yellow Gold",
                  marker: "None",
                  variantSku: "FCSTM_Earrings_Small_14K_None",
                  prefix: "",
                  mapId: "F14YAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "14K Yellow Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Earrings_Small_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14YAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "14K Yellow Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Earrings_Small_14K_Marker",
                  prefix: "D-",
                  mapId: "F14YAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "14K White Gold",
                  marker: "None",
                  variantSku: "FCSTM_Earrings_Small_14K_None",
                  prefix: "",
                  mapId: "F14WAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "14K White Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Earrings_Small_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14WAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Earrings",
                  shape: "Small",
                  materiel: "14K White Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Earrings_Small_14K_Marker",
                  prefix: "D-",
                  mapId: "F14WAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Gold Plated",
                  marker: "None",
                  variantSku: "CSTM_Ring_Oval_Plated_None",
                  prefix: "",
                  mapId: "GAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Gold Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Ring_Oval_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "GAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Gold Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Ring_Oval_Plated_Marker",
                  prefix: "D-",
                  mapId: "GAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Silver Plated",
                  marker: "None",
                  variantSku: "CSTM_Ring_Oval_Plated_None",
                  prefix: "",
                  mapId: "SAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Silver Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Ring_Oval_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "SAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Silver Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Ring_Oval_Plated_Marker",
                  prefix: "D-",
                  mapId: "SAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Sterling Silver",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Oval_Sterling_None",
                  prefix: "",
                  mapId: "FSAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Sterling Silver",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Oval_Sterling_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FSAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Sterling Silver",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Oval_Sterling_Marker",
                  prefix: "D-",
                  mapId: "FSAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Gold Vermeil",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Oval_Vermeil_None",
                  prefix: "",
                  mapId: "FVAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Gold Vermeil",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Oval_Vermeil_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FVAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "Gold Vermeil",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Oval_Vermeil_Marker",
                  prefix: "D-",
                  mapId: "FVAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "14K Yellow Gold",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Oval_14K_None",
                  prefix: "",
                  mapId: "F14YAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "14K Yellow Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Oval_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14YAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "14K Yellow Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Oval_14K_Marker",
                  prefix: "D-",
                  mapId: "F14YAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "14K White Gold",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Oval_14K_None",
                  prefix: "",
                  mapId: "F14WAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "14K White Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Oval_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14WAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Oval",
                  materiel: "14K White Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Oval_14K_Marker",
                  prefix: "D-",
                  mapId: "F14WAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "Gold Plated",
                  marker: "None",
                  variantSku: "CSTM_Ring_Circle_Plated_None",
                  prefix: "",
                  mapId: "GAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "Gold Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Ring_Circle_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "GAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "Gold Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Ring_Circle_Plated_Marker",
                  prefix: "D-",
                  mapId: "GAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "Sterling Silver",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Circle_Sterling_None",
                  prefix: "",
                  mapId: "FSAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "Sterling Silver",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Circle_Sterling_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FSAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "Sterling Silver",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Circle_Sterling_Marker",
                  prefix: "D-",
                  mapId: "FSAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "Gold Vermeil",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Circle_Vermeil_None",
                  prefix: "",
                  mapId: "FVAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "Gold Vermeil",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Circle_Vermeil_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FVAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "Gold Vermeil",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Circle_Vermeil_Marker",
                  prefix: "D-",
                  mapId: "FVAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "14K Yellow Gold",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Circle_14K_None",
                  prefix: "",
                  mapId: "F14YAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "14K Yellow Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Circle_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14YAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "14K Yellow Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Circle_14K_Marker",
                  prefix: "D-",
                  mapId: "F14YAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "14K White Gold",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Circle_14K_None",
                  prefix: "",
                  mapId: "F14WAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "14K White Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Circle_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14WAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Circle",
                  materiel: "14K White Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Circle_14K_Marker",
                  prefix: "D-",
                  mapId: "F14WAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "Gold Plated",
                  marker: "None",
                  variantSku: "CSTM_Ring_Square_Plated_None",
                  prefix: "",
                  mapId: "GAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "Gold Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Ring_Square_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "GAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "Gold Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Ring_Square_Plated_Marker",
                  prefix: "D-",
                  mapId: "GAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711790"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "Sterling Silver",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Square_Sterling_None",
                  prefix: "",
                  mapId: "FSAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "Sterling Silver",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Square_Sterling_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FSAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "Sterling Silver",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Square_Sterling_Marker",
                  prefix: "D-",
                  mapId: "FSAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "Gold Vermeil",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Square_Vermeil_None",
                  prefix: "",
                  mapId: "FVAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "Gold Vermeil",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Square_Vermeil_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FVAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "Gold Vermeil",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Square_Vermeil_Marker",
                  prefix: "D-",
                  mapId: "FVAAAAAA",
                  suffix: "-(SIZE)",
                  hs: "711311"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "14K Yellow Gold",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Square_14K_None",
                  prefix: "",
                  mapId: "F14YAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "14K Yellow Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Square_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14YAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "14K Yellow Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Square_14K_Marker",
                  prefix: "D-",
                  mapId: "F14YAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "14K White Gold",
                  marker: "None",
                  variantSku: "FCSTM_Ring_Square_14K_None",
                  prefix: "",
                  mapId: "F14WAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "14K White Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Ring_Square_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14WAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Ring",
                  shape: "Square",
                  materiel: "14K White Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Ring_Square_14K_Marker",
                  prefix: "D-",
                  mapId: "F14WAAAAA",
                  suffix: "-(SIZE)",
                  hs: "7113195021"
              },
              {
                  type: "Brooch",
                  shape: "",
                  materiel: "Gold Plated",
                  marker: "None",
                  variantSku: "CSTM_Brooch_Plated_None",
                  prefix: "",
                  mapId: "GAAAAAA",
                  suffix: "",
                  hs: "711790"
              },
              {
                  type: "Brooch",
                  shape: "",
                  materiel: "Gold Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Brooch_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "GAAAAAA",
                  suffix: "",
                  hs: "711790"
              },
              {
                  type: "Brooch",
                  shape: "",
                  materiel: "Gold Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Brooch_Plated_Marker",
                  prefix: "D-",
                  mapId: "GAAAAAA",
                  suffix: "",
                  hs: "711790"
              },
              {
                  type: "Brooch",
                  shape: "",
                  materiel: "Silver Plated",
                  marker: "None",
                  variantSku: "CSTM_Brooch_Plated_None",
                  prefix: "",
                  mapId: "GAAAAAA",
                  suffix: "",
                  hs: "711790"
              },
              {
                  type: "Brooch",
                  shape: "",
                  materiel: "Silver Plated",
                  marker: "Enamel",
                  variantSku: "CSTM_Brooch_Plated_Enamel",
                  prefix: "R/W/B-",
                  mapId: "GAAAAAA",
                  suffix: "",
                  hs: "711790"
              },
              {
                  type: "Brooch",
                  shape: "",
                  materiel: "Silver Plated",
                  marker: "Marker",
                  variantSku: "CSTM_Brooch_Plated_Marker",
                  prefix: "D-",
                  mapId: "GAAAAAA",
                  suffix: "",
                  hs: "711790"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "Sterling Silver",
                  marker: "None",
                  variantSku: "FCSTM_Cufflinks_Sterling_None",
                  prefix: "",
                  mapId: "FSAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "Sterling Silver",
                  marker: "Enamel",
                  variantSku: "FCSTM_Cufflinks_Sterling_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FSAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "Sterling Silver",
                  marker: "Marker",
                  variantSku: "FCSTM_Cufflinks_Sterling_Marker",
                  prefix: "D-",
                  mapId: "FSAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "Gold Vermeil",
                  marker: "None",
                  variantSku: "FCSTM_Cufflinks_Vermeil_None",
                  prefix: "",
                  mapId: "FVAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "Gold Vermeil",
                  marker: "Enamel",
                  variantSku: "FCSTM_Cufflinks_Vermeil_Enamel",
                  prefix: "R/W/B-",
                  mapId: "FVAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "Gold Vermeil",
                  marker: "Marker",
                  variantSku: "FCSTM_Cufflinks_Vermeil_Marker",
                  prefix: "D-",
                  mapId: "FVAAAAAA",
                  suffix: "-2",
                  hs: "711311"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "14K Yellow Gold",
                  marker: "None",
                  variantSku: "FCSTM_Cufflinks_14K_None",
                  prefix: "",
                  mapId: "F14YAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "14K Yellow Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Cufflinks_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14YAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "14K Yellow Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Cufflinks_14K_Marker",
                  prefix: "D-",
                  mapId: "F14YAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "14K White Gold",
                  marker: "None",
                  variantSku: "FCSTM_Cufflinks_14K_None",
                  prefix: "",
                  mapId: "F14WAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "14K White Gold",
                  marker: "Enamel",
                  variantSku: "FCSTM_Cufflinks_14K_Enamel",
                  prefix: "R/W/B-",
                  mapId: "F14WAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              },
              {
                  type: "Cufflinks",
                  shape: "",
                  materiel: "14K White Gold",
                  marker: "Marker",
                  variantSku: "FCSTM_Cufflinks_14K_Marker",
                  prefix: "D-",
                  mapId: "F14WAAAAA",
                  suffix: "-2",
                  hs: "7113195021"
              }
          ]
    };

    let customCSS = '<style id="materialhidesdiscounts">';
    // Step 1: Loop through all types and materials from price
    Object.keys(CONSTANTS.VARIANT_FROM_PRICE_VISIBILITY).forEach(AllType => {
      const VariantMaterials = CONSTANTS.VARIANT_FROM_PRICE_VISIBILITY[AllType];
      Object.keys(VariantMaterials).forEach(material1 => {
        // Step 2: If variant price visibility is false, hide that option
        if (!VariantMaterials[material1]) {
          customCSS += `
            div.Jewelry_map_product[data-selectedvariant="${AllType.toLowerCase()}"] 
            .option-jewelry-material[data-material="${material1}"] .from-money {
              display: none !important;
            }`;
        }
      });
    });

    customCSS += '</style>';
    document.head.insertAdjacentHTML('beforeend', customCSS);

    // =================================================================
    // 2. APPLICATION STATE
    // A single object to hold all dynamic variables.
    // =================================================================

    let appState = {
        jewelType: $('.option-jewelry-type input[type="radio"]:checked').closest('[data-name]').data('name') || 'Necklace',
        jewelColor: $('.option-jewelry-material input[type="radio"]:checked').closest('[data-id]').data('id') || 'Silver',
        jewelColorText: 'Gold',
        jewelSize: $('.option-jewelry-type-shape input[type="radio"]:checked').closest('[data-size]').data('size') || 'Medium',
        jewelLength: 'Short',
        jewelShape: 'Circle', // 1:Square, 2:Circle, 3:Rectangle, 4:Oval, 5:Pear
        variantName: "Statement", // Statement | Classic
        pinType: 'None', // None | Diamond | Heart | Pearl | Enamel
        enamelColor: 'White',
        selectedStyle: 4,
        mapView: 0, // 0: Map, 1: Jewelry Preview
        NecklaceSecVar: 'N/A',
        necklaceLength: 'Short', // Short | Medium
        earringChoice: 'Pair', // Pair | Single
        earringsSecVar: 'Stud', // Stud | Dangle
        ringSize: 'Size 4.5',
        ringSizeVal: '4.5',
        rotateRingVal: 'TopRight', // TopRight | TopLeft
        isMobile: (/Mobi|Android|iPhone|iPod/i.test(navigator.userAgent) || navigator.userAgentData?.mobile) && window.innerWidth < 925,
        isSearched: false,
        firstLoad: true,
        pin_enabled: false,
        map_center: CONSTANTS.DEFAULT_MAP_CENTER,
        pin_coords: CONSTANTS.DEFAULT_MAP_CENTER,
        mapWidth: jQuery('#left').width(),
        geojson: null,
        geojson1: null,
        constLat: 0,
        constLng:0,
        canvasMovesSinceReport:0,
        map:null,
        rightMap: null,
        canvas: null,
        pageURL:window.location.search,
        txtMaterialID: 'G',
        defPins:false,
        isCursorOverPoint: null
    };

    // =================================================================
    // 3. MAPBOX & API INTEGRATION
    // =================================================================
    let map, rightMap, compareMap, geocoder;
    if (appState.jewelType) {
      $('.Jewelry_map_product').attr('data-selectedvariant', appState.jewelType.toLowerCase());
      $('.Jewelry_map_product').attr('data-selectedshape', appState.jewelShape.toLowerCase());
      const loadtypeKey = Object.keys(CONSTANTS.VARIANT_VISIBILITY).find(key => key.toLowerCase() === appState.jewelType.toLowerCase());
      if (loadtypeKey) {
        // Loop through all materials under this type
        Object.keys(CONSTANTS.VARIANT_VISIBILITY[loadtypeKey]).forEach(mlkey => {
          const isloadthisVisible = CONSTANTS.VARIANT_VISIBILITY[loadtypeKey][mlkey];
          const thisloadMaterial = $('.Jewelry_map_product').find(`.option-jewelry-material[data-material="${mlkey}"]`);
          if (!isloadthisVisible) {
            thisloadMaterial.find('input').addClass('custom-unavailable');
          } else {
            thisloadMaterial.find('input').removeClass('custom-unavailable');
          }
        });
      }
    }

    /**
     * Initializes the Mapbox maps and geocoder control.
     */
    function initializeMaps() {
        try {

          try {
            setBeforeSettingsfromURL();
          } catch (error) {
            console.error('MAP_JEWELRY: Error in Before Settings',error);
          }

            mapboxgl.accessToken = CONSTANTS.MAPBOX_ACCESS_TOKEN;
            appState.map = new mapboxgl.Map({
                container: 'left',
                style: 'mapbox://styles/taliasari/cknii7ts30jyn17l4s4t5xh1s',
                center: appState.map_center,
                preserveDrawingBuffer: true,
                attributionControl: false,
                zoom: CONSTANTS.MAP_VARS.map_zoom_animation?CONSTANTS.MAP_VARS.map_startZoom:CONSTANTS.DEFAULT_MAP_ZOOM // start at lower zoom
            });

            $('#right').show();

            appState.rightMap = new mapboxgl.Map({
                container: 'right',
                style: 'mapbox://styles/taliasari/cknj6dvym07dq17np15xbj6nj',
                center: appState.map_center,
                attributionControl: false,
                zoom: CONSTANTS.MAP_VARS.map_zoom_animation?CONSTANTS.MAP_VARS.map_startZoom:CONSTANTS.DEFAULT_MAP_ZOOM
            });

            compareMap = new mapboxgl.Compare(appState.map, appState.rightMap, {});
            compareMap._setPosition($('#left').width());

            appState.canvas = appState.map.getCanvasContainer();

            var nav = new mapboxgl.NavigationControl();
            appState.map.addControl(nav, 'bottom-right');
            appState.map.dragRotate.disable();

            geocoder = new MapboxGeocoder({
                marker: false,
                accessToken: mapboxgl.accessToken,
                mapboxgl: mapboxgl,
                zoom: appState.map.getZoom(),
                placeholder: $('#search-field-desktop').data('placeholder') ||  'Enter a place / address',
                flyTo: {
                    duration: CONSTANTS.MAP_VARS.map_easeTo
                }
            });

            if(appState.isMobile){
              $('#search-field-mobile #geocoder').empty().append(geocoder.onAdd(appState.map));
            }else{
              $('#search-field-desktop #geocoder').empty().append(geocoder.onAdd(appState.map));
            }

            geocoder.on('result', function (event) {
                try {
                  
                    const inputSelector = appState.isMobile ? '#search-field-mobile #geocoder .mapboxgl-ctrl-geocoder--input' : '#search-field-desktop #geocoder .mapboxgl-ctrl-geocoder--input';
                    $(inputSelector).blur();

                    handleGeocoderResult(event);
                } catch (err) {
                    // Step 5: Handle errors
                    console.error('MAP_JEWELRY: Geocoder handler error:', err);
                }
            });

            // geocoder.on('result', handleGeocoderResult);

            const handleMapUpdate = () => {
              appState.map_center = appState.map.getCenter();
              updateAll();
            };

            appState.map.on('moveend', debouncedUpdateAll);
            appState.map.on('zoomend', debouncedUpdateAll);
            appState.rightMap.on('zoomend', debouncedUpdateAll);
            appState.rightMap.on('moveend', debouncedUpdateAll);
            appState.rightMap.on('rotateend', debouncedUpdateAll);

            appState.rightMap.on('load', function (e) {

              appState.rightMap.resize();
              $('#right .mapboxgl-canvas').attr('height',$('#right .mapboxgl-canvas').attr('width'));

            });

          appState.map.on('load', function (e) {

            appState.map.easeTo({
              center: appState.map_center,
              zoom: CONSTANTS.DEFAULT_MAP_ZOOM, // zoom in to this level
              duration: CONSTANTS.MAP_VARS.map_zoomDuration, // animation duration (ms)
              easing: (t) => t    // linear easing; you can customize
            });

            jQuery('#left').height(jQuery('#left').width());
            appState.map.resize();

            appState.geojson = {
              "type": "FeatureCollection",
              "features": [{
              "type": "Feature",
              "geometry": {
              "type": "Point",
              "coordinates": CONSTANTS.DEFAULT_MAP_CENTER
              }
              }]
            };

            appState.map.addSource('point', {
              "type": "geojson",
              "data": appState.geojson
            });

            appState.map.addLayer({
              "id": "point",
              "type": "circle",
              "source": "point",
              "paint": {
              "circle-radius": 10,
              "circle-color": "#C1272D"
              }
            });

            //blue dot code START
            appState.geojson1 = {
              "type": "FeatureCollection",
              "features": [{
              "type": "Feature",
              "geometry": {
              "type": "Point",
              "coordinates": CONSTANTS.DEFAULT_MAP_CENTER
              }
              }]
            };

            appState.map.addSource('point1', {
              "type": "geojson",
              "data": appState.geojson1
            });

            appState.map.addLayer({
              "id": "point1",
              "type": "circle",
              "source": "point1",
              "paint": {
              "circle-opacity": .6,
              "circle-radius": 7,
              "circle-color": "#0075ff"
              }
            });
            //blue dot code END

            appState.map.on('mouseenter', 'point', function () {
              appState.map.setPaintProperty('point', 'circle-color', '#C1272D');
              appState.canvas.style.cursor = 'move';
            });

            appState.map.on('mouseleave', 'point', function () {
              appState.map.setPaintProperty('point', 'circle-color', '#C1272D');
              appState.canvas.style.cursor = '';
            });

            appState.map.on('mousedown', 'point', function (e) {
              // Prevent the default map drag behavior.
              e.preventDefault();
              appState.canvas.style.cursor = 'grab';
              appState.map.on('mousemove', onMove);
              appState.map.once('mouseup', onUp);
            });

            appState.map.on('touchstart', 'point', function (e) {
              if (e.points.length !== 1) return;
              // Prevent the default map drag behavior.
              e.preventDefault();
              appState.map.on('touchmove', onMove);
              appState.map.once('touchend', onUp);
            });

            var el = document.createElement('div');
            el.className = 'marker';

            var marker = new mapboxgl.Marker(el, {
             draggable: true
            }).setLngLat(CONSTANTS.DEFAULT_MAP_CENTER).addTo(appState.rightMap);

            document.marker = marker;

            var els = document.createElement('div');
            els.className = 'marker_black';

            var marker_black = new mapboxgl.Marker(els, {
             draggable: false
            }).setLngLat(CONSTANTS.DEFAULT_MAP_CENTER).addTo(appState.map);

            document.marker_black = marker_black;

            setFormVariables(appState.map, 13);

            // When the cursor enters a feature in the point layer, prepare for dragging.
            appState.map.on('mouseenter', 'point', function (e) {
              appState.canvas.style.cursor = 'move';
              appState.isCursorOverPoint = true;
              appState.map.dragPan.disable();
            });

            appState.map.on('mouseleave', 'point', function (e) {
              appState.canvas.style.cursor = '';
              appState.isCursorOverPoint = false;
              appState.map.dragPan.enable();
              updateLuckyOrangeOnMapChange()
            });

            showHideMarker(appState.map.getCenter().lng, appState.map.getCenter().lat, 'None');
            showHideBlueMarker(appState.map.getCenter().lng, appState.map.getCenter().lat, 'None');

            var params = URLToArray(appState.pageURL);
            setAfterSettingsfromURL(params);

            appState.firstLoad = false;
            appState.rightMap.on('style.load', function (e) {
              updateMapLayers();
            });
          });

          jQuery('#left').height(jQuery('#left').width());

        } catch (error) {
            console.error("MAP_JEWELRY: Failed to initialize maps:", error);
        }
    }

    // =================================================================
    // 4. UI UPDATE FUNCTIONS
    // These functions read from `appState` and update the DOM.
    // =================================================================

    /**
     * A master function to update all relevant UI parts based on the current state.
     */
    function updateAll() {
        updateMapOverlays();
        updateMapLayers();
        setFormVariables(appState.map,13);
        updateMapMarker();
    }

    function debounce(func, timeout = 300) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
      }

    const debouncedUpdateAll = debounce(function() {
        appState.map_center = appState.map.getCenter();
        updateAll(); 
    }, 300);

    function rotateRing(ringVal) {
      appState.rotateRingVal = ringVal;
      const isOvalRing = appState.jewelSize?.toLowerCase() === 'oval' && appState.jewelType?.toLowerCase() === 'ring';
      $('.flip_icon').toggle(isOvalRing);
      $('#new-over, #overlay-left, #overlay-right').toggleClass('rotate-ring', ringVal === 'TopLeft');
    }
    
  function mouseDown() {
    if (!appState.isCursorOverPoint) return;
    //Set a cursor indicator
    appState.canvas.style.cursor = 'grab';
    updateLuckyOrangeOnMapChange()
    // Mouse events
    appState.map.on('mousemove', onMove);
    appState.map.once('mouseup', onUp);
  }

  function onMove(e) {
    var coords = e.lngLat;
    e.originalEvent.stopPropagation();

    // Set a UI indicator for dragging.
    appState.canvas.style.cursor = 'grabbing';

    // Update the Point feature in `geojson` coordinates and call setData to the source layer `point` on it.
    appState.geojson.features[0].geometry.coordinates = [coords.lng, coords.lat];
    appState.map.getSource('point').setData(appState.geojson);
    updateLuckyOrangeOnMapChange()
  }

  function onUp(e) {
    var coords = e.lngLat;

    appState.canvas.style.cursor = 'grab';

    // Unbind mouse events
    appState.map.off('mousemove', onMove);
    appState.map.off('touchmove', onMove);

    updateLuckyOrangeOnMapChange();

    centerPearlMarker([getPinCoords()[0], getPinCoords()[1]]);
    setFormVariables(appState.map, 14);
  }

  function centerBlackMarker(center) {
    document.marker_black.setLngLat(center)
  }

  function centerPearlMarker(center) {
    document.marker.setLngLat(center);
  }

  function createRedMarker(lng, lat) {
    appState.geojson = {
      "type": "FeatureCollection",
      "features": [{
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": [lng, lat]
        }
      }]
    };
    appState.map.getSource('point').setData(appState.geojson);
    appState.map.setLayoutProperty('point', 'visibility', 'visible');
  }

  function createBlueMarker(lng, lat) {
    appState.geojson1 = {
      "type": "FeatureCollection",
      "features": [{
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": [lng, lat]
        }
      }]
    };

    appState.map.getSource('point1').setData(appState.geojson1);
    appState.map.setLayoutProperty('point1', 'visibility', 'visible');
  }

    function showHideBlueMarker(lng, lat, showHide) {
      appState.map.setLayoutProperty('point1', 'visibility', 'none');
      if (showHide == 'Show') {
        createBlueMarker(lng, lat);
      }
    }

    function showHideMarkerSearch(lng, lat, lastPin) {
      //hide
      appState.pin_enabled = false;
      $('.mapboxgl-canvas-container .marker,.marker_black').hide();
      appState.map.setLayoutProperty('point', 'visibility', 'none');
      
      //show
      if (appState.pinType == 'None') {
        $('.marker_black').show();
      } else {
        appState.pin_enabled = true;
        $('.mapboxgl-canvas-container .marker').show();
        if (lastPin == 'None' && !appState.isSearched) {
          lng = appState.map.getCenter().lng;
          lat = appState.map.getCenter().lat;
          centerPearlMarker([lng, lat]); // when last pin is None then center the marker
        }
        
        createRedMarker(lng, lat);

      }
    }

    let isFirstNone = null;

    function showHideMarker(lng, lat, lastPin, changeMarker=false) {
      //hide
      appState.pin_enabled = false;
      $('.mapboxgl-canvas-container .marker,.marker_black').hide();
      appState.map.setLayoutProperty('point', 'visibility', 'none');

      if(changeMarker && lastPin != 'None'){
        isFirstNone = true;
      }

      //show
      if (appState.pinType == 'None') {
        $('.marker_black').show();
      } else {
        appState.pin_enabled = true;
        $('.mapboxgl-canvas-container .marker').show();

        // if (lastPin == 'None' && !appState.isSearched) {
        if (lastPin == 'None' && isFirstNone) {
          lng = appState.map.getCenter().lng;
          lat = appState.map.getCenter().lat;
          centerPearlMarker([lng, lat]); // when last pin is None then center the marker

          // if(appState.isMobile){
          //   setTimeout(() => {
          //   // Step 1: Select the element
          //   var $div = $('#right .mapboxgl-marker');
          //   var transformValue = $div.attr('style'); // get the actual style string
          //   // Extract only the transform part
          //   var match = transformValue.match(/transform:\s*([^;]+)/);
          //   if (match) {
          //     var newTransform = match[1].replace('translate(-50%, -50%)', 'translate(-50%, -150%)');
          //     $div.css('transform', newTransform);
          //   }
          //   }, 1);
          // }
        }

        createRedMarker(lng, lat);

        if(changeMarker){
          positionRedMarker();
        }

      }
    }

    function getPinCoords() {
      if (appState.geojson) {
        return appState.geojson.features[0].geometry.coordinates
      } else {
        return [0, 0]
      }
    }

    function updateLuckyOrangeOnMapChange() {
      if (!window.LO) {
          return;
      }
      if (appState.canvasMovesSinceReport !== 25) {
          appState.canvasMovesSinceReport += 1;
          return;
      }
      window.LO.update_canvas('canvas');
      appState.canvasMovesSinceReport = 0;
    }
    /**
     * Updates the map overlay styles (shape, size, color).
     */
    function updateMapOverlays() {
        const shape = CONSTANTS.SHAPE_ARRAY[appState.jewelShape] ? CONSTANTS.SHAPE_ARRAY[appState.jewelShape].toLowerCase() : (appState.jewelShape?appState.jewelShape.toLowerCase():'');
        const size = appState.jewelSize?appState.jewelSize.toLowerCase():'';
        const color = appState.jewelColor?appState.jewelColor.toLowerCase():'';
        var classes = '';
        if(size.toLowerCase() == 'oval'){
          classes = `${size} ${color}`;
        }else{
          classes = `${shape} ${size} ${color}`;
        }

        const isOvalRing = appState.jewelSize?.toLowerCase() === 'oval' && appState.jewelType?.toLowerCase() === 'ring' && appState.rotateRingVal === 'TopLeft';
        if (isOvalRing) {
          classes = classes + ' rotate-ring';
        }

        $('#new-over, #overlay-right, #overlay-left').attr('class', classes);
        $('#new-over, #overlay-right, #overlay-left').attr('data-id', appState.jewelType);

        // Preview text color logic
        const isGoldTone = ['Gold', 'Vermeil', 'Yellow', 'Plated'].some(tone => {
          return appState.jewelColor ? appState.jewelColor.includes(tone) : false;
        });

        $('.preview-text, .preview-text-desk').toggleClass('preview-text-silver', !isGoldTone);
    }

    /**
     * Shows or hides Mapbox layers based on selected style and color.
     */

    function hideMapboxLayers() {
        const goldLayers = CONSTANTS.LAYER_SETS.gold;
        const silverLayers = CONSTANTS.LAYER_SETS.silver;

        goldLayers.forEach(gLayer => {
            appState.rightMap.setLayoutProperty(gLayer, "visibility", "none");
        });

        silverLayers.forEach(sLayer => {
            appState.rightMap.setLayoutProperty(sLayer, "visibility", "none");
        });
    }

    function updateMapLayers() {
        if (!appState.rightMap || !appState.rightMap.isStyleLoaded()){
          return; // Guard clause
        }
        const isGoldTone = ['Gold', 'Vermeil', 'Yellow', 'Plated'].some(tone => {
          return appState.jewelColor ? appState.jewelColor.includes(tone) : false;
        });
        const layersToShow = isGoldTone ? CONSTANTS.ALL_GOLD_LAYERS[appState.selectedStyle] : CONSTANTS.ALL_SILVER_LAYERS[appState.selectedStyle];
        const allLayers = isGoldTone ? CONSTANTS.LAYER_SETS.gold : CONSTANTS.LAYER_SETS.silver;

        hideMapboxLayers();

        try {
        $.each(allLayers, function (index, value) {
            if ($.inArray(value, layersToShow) !== -1) {
                appState.rightMap.setLayoutProperty(value, 'visibility', 'visible');
            } else {
                appState.rightMap.setLayoutProperty(value, 'visibility', 'none');
            }
        });
        } catch (error) {
            console.error("MAP_JEWELRY: Error updating map layers:", error);
        }
    }

    /**
     * Updates the pin/marker's appearance.
     */
    function updateMapMarker() {
      let enamelClass = 'en-white';
      if(appState.enamelColor == 'white' || appState.enamelColor == 'White'){
        enamelClass = 'en-white';
      }else if(appState.enamelColor == 'red' || appState.enamelColor == 'Red'){
        enamelClass = 'heart';
      }else{
        enamelClass = 'en-black';
      }
      const jColor = appState.jewelColor?appState.jewelColor.toLowerCase():'';
      const shape = CONSTANTS.SHAPE_ARRAY[appState.jewelShape] ? CONSTANTS.SHAPE_ARRAY[appState.jewelShape].toLowerCase() : (appState.jewelShape?appState.jewelShape.toLowerCase():'');
      const markerClass = `mapboxgl-marker marker ${appState.pinType.toLowerCase()} ${jColor} ${appState.variantName.toLowerCase()} ${shape} ${appState.jewelType?appState.jewelType.toLowerCase():''} ${enamelClass}`;
      $('.mapboxgl-canvas-container .marker').attr('class', markerClass);
    }

    // =================================================================
    // 5. EVENT HANDLER LOGIC
    // These functions contain the logic executed on user interaction.
    // =================================================================

    /**
     * Handles the selection of a new jewelry type (Necklace, Ring, etc.).
     * @param {HTMLElement} element - The clicked element.
     */
    let selectedType = null;
    function handleJewelryTypeChange(element) {
      let oldJewelType = appState.jewelType;
        if(oldJewelType.toLowerCase() == 'ring'){
          appState.jewelSize = 'Small';
        }

        appState.jewelType = $(element).data('name');

        if (appState.jewelType) {
          $('.Jewelry_map_product').attr('data-selectedvariant', appState.jewelType.toLowerCase());
        }

        selectedType = $(element).data('type');

        $('.marker-jewelry-type').hide().filter(`[data-variant="${selectedType}"]`).show(); // show hide type labels

        $(element).closest('.map-option-section').find('input').removeClass('checked'); 
        $(element).find('input').addClass('checked');

        if ($(element).find('input').attr('name') !== '[display-Type]') {
            $('#visually_hidden_dummy_input').addClass('checked').prop('checked', true).trigger('change');
        }

        setTimeout(() => {
          const $selected = $('.option-jewelry-material input[type="radio"][name="options[Material]"]:checked');
          if ($selected.hasClass('unavailable')) {

          let my_current_material_fullname = [];

          if(appState.jewelColor == 'Gold' || appState.jewelColor == 'Plated' || appState.jewelColor == 'Vermeil' || appState.jewelColor == 'Gold Vermeil' || appState.jewelColor == 'Yellow' || appState.jewelColor == '14K Gold'){
            my_current_material_fullname = ['Plated', 'Gold Vermeil','14k Gold'];
          }else{
            my_current_material_fullname = ['Silver', 'Sterling Silver','White'];
          }

            const myselector = my_current_material_fullname.map(val => `.option-jewelry-material[data-id="${val}"] input[type="radio"][name="options[Material]"]:not(.unavailable)`).join(',');

            let $firstAvailable = $(myselector).first();

            if($firstAvailable.length == 0){
              $firstAvailable = $('.option-jewelry-material input[type="radio"][name="options[Material]"]:not(.unavailable)').first();
            }
            
            if ($firstAvailable.length) {
              $firstAvailable.closest('.option-jewelry-material').find('label[for="' + $firstAvailable.attr('id') + '"]').trigger('click');
            }
          }
        }, 200);

        handleMaterialChange($('.option-jewelry-material input[type="radio"].checked').closest('[data-id]') || $('.option-jewelry-material input[type="radio"]:checked').closest('[data-id]'),false);

        //2. material
        if(appState.jewelColor){
          if(appState.jewelColor == 'Silver' || appState.jewelColor == 'White'){
            setTimeout(() => {
              $('.option-jewelry-material[data-id="' + appState.jewelColor + '"]').find('label').trigger('click');
            }, 500);
          }
        }

        let foundMatch = false;
        $('.map-option-shape-section .option-jewelry-type-shape').each(function () { // variant small/large show and selected first
            const $this = $(this);
            const shape = $this.data('shape');
            if (shape === selectedType) {
              if(shape.toLowerCase() == 'ring'){
                if (!foundMatch) {
                  $this.find('label').trigger('click');
                  foundMatch = true;
                }
              }else{
                if (!foundMatch && $this.data('size').toLowerCase() == String(appState.jewelSize).toLowerCase()) {
                  $this.find('label').trigger('click');
                  foundMatch = true;
                }
              }

              if(shape.toLowerCase() == 'ring'){
                const inputVal = ($this.find('input').val() || '').toLowerCase();
                const myjewelShape = appState.jewelShape ? String(appState.jewelShape).toLowerCase(): '';
                if (inputVal.includes(myjewelShape)) {
                  setTimeout(() => {
                  $this.find('label').trigger('click');
                  }, 201);
                }
              }

              $this.toggle(!(shape === 'Necklace' || shape === 'Earrings'));
            } else {
              $this.hide();
            }
        });

          const $shapes = $('.map-option-shape-section .option-jewelry-type-jewelshape');
          let foundShapeMatchandcheced = false;
          $shapes.each(function () {
            const $this = $(this);
            const shape = $this.data('variant');
            if (shape === selectedType) {
              const inputVal = ($this.find('input').val() || '').toLowerCase();
              const myyjewelShape = appState.jewelShape? String(appState.jewelShape).toLowerCase(): '';

              if (inputVal === myyjewelShape) {
                $this.find('label').trigger('click');
                setTimeout(() => {
                  $this.find('label').trigger('click');
                }, 201);
                foundShapeMatchandcheced = true;
              }
              $this.show();
            } else {
              $this.hide();
            }
          });

          // If no match found, trigger the first visible label
          if (!foundShapeMatchandcheced) {
            const $firstVisible = $shapes.filter(function() {
              return $(this).data('variant') === selectedType;
            }).first();

            if ($firstVisible.length) {
              $firstVisible.find('label').trigger('click');
            }
          }

        // option-jewelry-select-option
        $('fieldset.option-jewelry-select-option').hide().filter(`[data-variant="${selectedType}"]`).show();
        // jewelry-select-type-ChainSize
        const $targetLi = $(`.option-jewelry-select-type-ChainSize[data-variant="${selectedType}"] ul li a[data-size="${String(appState.jewelSize).toLowerCase()}"]`);
        let sizevalue;
        if ($targetLi.length > 0) {
          const el = $targetLi[0];
            if (el) {
              // Temporarily attach a listener that prevents default behavior
              const preventDefaultHandler = e => e.preventDefault();
              el.addEventListener('click', preventDefaultHandler, true);
              // Dispatch the native click
              el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
              // Remove the temporary listener
              el.removeEventListener('click', preventDefaultHandler, true);
            }
          
          sizevalue = appState.jewelSize;

        }else{
          let $sizeinput = $(`.option-jewelry-select-type-ChainSize[data-variant="${selectedType}"] input`);
          sizevalue = $sizeinput.val()?.toLowerCase() || 'small';
        }

        const broochjewelsize = sizevalue.includes('small') ? 'small' : 'large';
        const $checkedColor = $('.option-jewelry-material input[type="radio"]:checked');
        
        const $checkedShape = $(`.option-jewelry-type-shape[data-shape="${selectedType}"] input[type="radio"]:checked`);
        const $checkedJewelShape = $(`.option-jewelry-type-jewelshape[data-variant="${selectedType}"] input[type="radio"]:checked`);
        appState.jewelSize = $checkedShape.closest('[data-size]').data('size') || broochjewelsize;
        appState.jewelColor = $checkedColor.closest('[data-id]').data('id') || 'Silver';
        if($checkedJewelShape.length){
          appState.jewelShape = $checkedJewelShape.val() || 'Circle';
          if (appState.jewelShape) {
            $('.Jewelry_map_product').attr('data-selectedshape', appState.jewelShape.toLowerCase());
          }
        }

        switch (appState.jewelType) {
          case 'Ring':
            appState.jewelSize = 'Small';
            break;
          case 'Tie Clip':
            appState.jewelSize = 'Small';
            break;
          case 'Cufflinks':
            appState.variantName = 'Classic';
            appState.jewelSize = 'Small';
            break;
        }

        const $ringMarkers = $('.marker-jewelry-type-ring-shape-strings');

      if (appState.jewelType.toLowerCase() === 'ring') {
        $ringMarkers.hide();
        $('.marker-jewelry-type-ring-shape-strings[data-lshape="' + String(appState.jewelShape).toLowerCase() + '"]').show();
      }else{
        $ringMarkers.hide();
      }

      updateAll(); 
      setTimeout(() => {
        $('span[data-label="Marker"][data-option-value]').text(appState.pinType);
      }, 222);
    }

    /**
     * Handles the selection of a material (Gold, Silver, etc.).
     * @param {HTMLElement} element - The clicked element.
     */

    var inputMaterialRef = null;
    function handleMaterialChange(element, updateAllcall = true) {

        appState.jewelColor = $(element).data('id');
        const materialInput = $(element).find('input');
        const inputRef = $(element).find('input').data('input');

        if (inputRef) {
          setTimeout(() => {
            appState.jewelColor = $(element).data('id');
            $(element).closest('.map-option-section').find('input').removeClass('checked');
            $(element).find('input').addClass('checked');
            var valueLabel = $(element).find('.value-label').text();
            $(element).closest('fieldset').find('[data-option-value]').text(valueLabel);
            appState.jewelColorText = $(element).data('txt');
            if(updateAllcall){
                updateAll();
            }
          }, 200);
        }

        $(element).closest('.map-option-section').find('input').removeClass('checked');
        $(element).find('input').addClass('checked');

        setTimeout(() => {
            var valueLabel = $(element).find('.value-label').text();
            $(element).closest('fieldset').find('[data-option-value]').text(valueLabel);

          // unavailable logic 
          const parentProduct = $(element).closest('.Jewelry_map_product');
          const type = parentProduct.attr('data-selectedvariant');
          const material = $(element).attr('data-material');
          const addToCartBtn = parentProduct.find('#AddToCart-product');

          // Normalize case-insensitive lookup
          const typeKey = Object.keys(CONSTANTS.VARIANT_VISIBILITY).find(key => key.toLowerCase() === type.toLowerCase());
          const materialKey = typeKey ? Object.keys(CONSTANTS.VARIANT_VISIBILITY[typeKey]).find(key => key.toLowerCase() === material.toLowerCase()): null;
          // Check visibility from CONSTANTS
          console.log('VARIANT_VISIBILITY',CONSTANTS.VARIANT_VISIBILITY[typeKey]);
          console.log('materialKey',materialKey);
          
          const isVisible = typeKey && materialKey? CONSTANTS.VARIANT_VISIBILITY[typeKey][materialKey]: false;
          console.log('isVisible',isVisible);

          if (!isVisible || materialInput.hasClass('unavailable')) {
            // Disable and change text
            addToCartBtn.find('[data-add-to-cart-text]').text('Unavailable');
            addToCartBtn.prop('disabled', true);
            addToCartBtn.addClass('custom-unavailable');
            materialInput.addClass('custom-unavailable');
            $(element).addClass('custom-unavailable');
          } else {
            // Re-enable and restore text            
              addToCartBtn.find('[data-add-to-cart-text]').text('Add to Cart');
              addToCartBtn.prop('disabled', false);
              addToCartBtn.removeClass('custom-unavailable');
              materialInput.removeClass('custom-unavailable');
              $(element).removeClass('custom-unavailable');
          }

          if (typeKey) {
            // Loop through all materials under this type
            Object.keys(CONSTANTS.VARIANT_VISIBILITY[typeKey]).forEach(mkey => {
              const isthisVisible = CONSTANTS.VARIANT_VISIBILITY[typeKey][mkey];
              const thisMaterial = parentProduct.find(`.option-jewelry-material[data-material="${mkey}"]`);
              if (!isthisVisible) {
                thisMaterial.addClass('custom-unavailable');
                thisMaterial.find('input').addClass('custom-unavailable');
              } else {
                thisMaterial.removeClass('custom-unavailable');
                thisMaterial.find('input').removeClass('custom-unavailable');
              }
            });
          }
        // unavailable logic End 

        }, 111);

        appState.jewelColorText = $(element).data('txt');

        setTimeout(() => {
          $('span[data-label="Marker"][data-option-value]').text(appState.pinType);
        }, 200);
        
        if(updateAllcall && !inputRef){
          updateAll();
        }
    }
    
    /**
     * Handles geocoder search result.
     * @param {object} result - The result object from Mapbox Geocoder.
     */
    function handleGeocoderResult(result) {
        // const inputSelector = '#geocoder .mapboxgl-ctrl-geocoder--input';
        // $(inputSelector).blur();

        let ua = navigator.userAgent;
        ua = ua.toLowerCase();
        let isAndroid = ua.includes("android");
        let timeouttime = isAndroid?350:0;

         appState.isSearched = true;
         const coords = result.result.center;
        //  setCenter(coords);
         appState.map_center = coords;
         appState.pin_coords = coords;

        //  address change
        var address = '';
        if (result.result.address) {
          address += result.result.address + ' ';
        }
        address += result.result.text;
        var region = '';
        var country = '';
        var place = '';
        var locality = '';

        $.each(result.result.context, function (key, val) {
          if (val.id.indexOf('region') != -1) {
            region = val.text;
          }
          if (val.id.indexOf('country') != -1) {
            country = val.text;
          }
          if (val.id.indexOf('place') != -1) {
            place = val.text;
          }
          if (val.id.indexOf('locality') != -1) {
            locality = val.text;
          }
        });

        var fullAddressNew = address;
        if (locality != '') {
          fullAddressNew += ', ' + locality;
        }
        if (place != '') {
          fullAddressNew += ', ' + place;
        }

        var address_TXT = result.result.place_name;
         var len = address_TXT.length;
        address_TXT = address_TXT.slice(0, 30);
        if (len > 30) {
          address_TXT += '...';
        }

        $('.search-field-label').html(address_TXT);
        $('#my_new_address').val(fullAddressNew); 
        // address change 

        let pinLng = coords[0];
        let pinLat = coords[1];

        appState.constLng = result.result.center[0];
        appState.constLat = result.result.center[1];

        showHideMarkerSearch(pinLng, pinLat, 'None');
        showHideBlueMarker(pinLng, pinLat, 'Show');

        centerBlackMarker(appState.map_center);

        if(CONSTANTS.MAP_VARS.map_zoom_animation){
            if(isAndroid){
              setTimeout(() => {
                  appState.map.flyTo({ center: coords, zoom: CONSTANTS.DEFAULT_MAP_ZOOM });
              }, timeouttime);
            }

            // Update map center
            appState.map.flyTo({ center: coords, zoom: CONSTANTS.DEFAULT_MAP_ZOOM });
            //  appState.map.flyTo({ center: coords, zoom: appState.map.getZoom() });
        }else{
           setCenter(coords);
        }
        setTimeout(() => {
          centerPearlMarker([pinLng, pinLat]); // center marker when address changed.
        }, 500);

         updateAll();

    }


    async function copyToClip(text) {
        const input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        const result = document.execCommand('copy');
        document.body.removeChild(input);
        return result;
    }

    function setBeforeSettingsfromURL(){
        var params = URLToArray(appState.pageURL);

        if(!params['id']){
          return;
        }

        if (params['lng'] && params['lat']) {
          appState.map_center = [params.lng, params.lat];

          if(params.address){
            appState.constLng = params.lng;
            appState.constLat = params.lat;
          }

        }

        if (params['zoom']) {
          CONSTANTS.DEFAULT_MAP_ZOOM = params.zoom
        }

        if (params['style_id']) {
          appState.selectedStyle = params.style_id;
        }

        if (params['map_view']) {
          appState.mapView = params.map_view;
        }

        if (params['id'] && params['pin_lng'] && params['pin_lat']) {
          var id = params.id;
          var res = id.split("-");

          if (res[3] == 'P' || res[3] == 'E' || res[3] == 'H' || res[3] == 'D') {
            appState.pinType = 'Pearl';
            if (res[3] == 'E') {
              appState.pinType = 'Enamel';

              $('.option-jewelry-marker[data-id="Enamel"]').trigger('click');
              $('.map-jewelry-marker-color-option').show();

              let current_enamel_color_4_ = res[4];
              let current_enamel_color_5_ = res[5];
              
              if(current_enamel_color_4_ == 'B' || current_enamel_color_5_ == 'B'){
                $('.option-jewelry-marker-color input[type="radio"][value="Black"]').trigger('click');
              }

            } else if (res[3] == 'H') {
              appState.pinType = 'Heart';
              $('.option-jewelry-marker[data-id="heart"]').click();
            } else if (res[3] == 'D') {
              appState.pinType = 'Diamond';
              setTimeout(() => {
                $('.option-jewelry-marker[data-id="Diamond"]').click();
              }, 101);
            }

            if(res[3] != 'N'){
              appState.pin_enabled = true;            
            }

            CONSTANTS.DEFAULT_MAP_CENTER = [params.pin_lng, params.pin_lat];
            appState.defPins = true;
          }
        }
    }

    function setAfterSettingsfromURL(params) {
        var res = new Array();

        if ('URLSearchParams' in window) {
          const myurl = new URL(window.location.href);
          myurl.search = '';
          const cleanedUrl = myurl.pathname;
          history.pushState(null, '', cleanedUrl);
        }

        if (params.id) {
          var id = params.id;
          res = id.split("-");
        } else {
          return;
        }

        if (params.map_view == 1) {
            selectView('preview');
        }

        appState.selectedStyle = params.style_id;

        $(`.h1Prvs[data-name="${String(params.style_id).toLowerCase()}"]`).trigger('click');

        if(params.address){
          if(appState.isMobile){
            $('#search-field-mobile #geocoder .mapboxgl-ctrl-geocoder--input').val(params.address);
          }else{
            $('#search-field-desktop #geocoder .mapboxgl-ctrl-geocoder--input').val(params.address);
          }

          const addparts = params.address.split(",");
          if(addparts && addparts[0]){
            const first = addparts[0].trim();
              $('#my_new_address').val(first); 
          }

         $('#my_address').val(params.address);

          var address_TXT = params.address;
          var len = address_TXT.length;
          address_TXT = address_TXT.slice(0, 30);
          if (len > 30) {
          address_TXT += '...';
          }

          $('.search-field-label').html(address_TXT);

        }

        if (res[2] && res[2].length > 1) {
          const size_shape_parts = res[2].split('');
          const size_part = size_shape_parts[0];
          let current_size = 'large';
            if (size_part == 'L') {
              current_size = 'large';
            } else if (size_part == 'S') {
              current_size = 'small';
            } else if (size_part == 'M') {
              current_size = 'medium';
            }else if(size_part == 'R'){
              current_size = '';
            }

            if(current_size){
              const $targetsizeLi = $(`.option-jewelry-select-type-ChainSize[data-variant="${appState.jewelType}"] ul li a[data-size="${String(current_size).toLowerCase()}"]`);
              if ($targetsizeLi.length > 0) {
                const el = $targetsizeLi[0];
                  if (el) {
                    el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
                  }
              }
            }

          const shape_part = size_shape_parts[1];
          let current_shape = '';
            if (shape_part == 'S') {
              current_shape = 'Square';
            } else if (shape_part == 'C') {
              current_shape = 'Circle';
            } else if (shape_part == 'R') {
              current_shape = 'Rectangle';
            } else if (shape_part == 'O') {
              current_shape = 'Oval';
            }else if (shape_part == 'P') {
              current_shape = 'Pear';
            }

            if(current_shape){
              let $checkedcurrentJewelShape = null;
              if(res[1] == 'R'){
                $checkedcurrentJewelShape = $(`.option-jewelry-type-shape[data-shape="${appState.jewelType}"][data-size="${current_shape}"] input`);

                 $('body div.Jewelry_map_product[data-selectedvariant="ring"] .option-jewelry-type-shape[data-shape="Ring"]').show();

                 $('.option-jewelry-select-type-ChainLength[data-variant="Necklace"]').hide();

                  let sizeString = '';
                  let prefix = '';
                  if (res[1] == 'R'){

                    if(size_part =='R') {

                      if(shape_part == 'O'){
                        let chain_parts = res[4].split('*');
                        prefix = chain_parts[0];// 'TR' or whatever comes before '*'
                        sizeString = chain_parts[1]; //4.5
                      }else{
                        sizeString = res[4];
                      }

                      if(sizeString){
                        const $targetsizestringLi = $(`.option-jewelry-select-type-ChainSize[data-variant="${appState.jewelType}"] ul li a[data-value="Size ${String(sizeString).toLowerCase()}"]`);
                        if ($targetsizestringLi.length > 0) {
                          const el = $targetsizestringLi[0];
                            if (el) {
                              el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
                            }
                        }
                      }
                      if(prefix){
                        rotateRing(prefix == 'TR' ? 'TopRight' : 'TopLeft');
                      }
                    }
                  }

              }else{
                $checkedcurrentJewelShape = $(`.option-jewelry-type-jewelshape[data-variant="${appState.jewelType}"] input[type="radio"][value="${current_shape}"]`);
              }
              if ($checkedcurrentJewelShape && $checkedcurrentJewelShape.length > 0) {
                const elshape = $checkedcurrentJewelShape[0];
                  if (elshape) {
                    elshape.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
                  }
              }

              if(res[1] == 'N' && res[4]){
                let current_jewelLength = 'short';
                  if(res[4] == 'M'){
                    current_jewelLength = 'medium'
                  }
                        const $targetsizestringLichain = $(`.option-jewelry-select-type-ChainLength ul li a[data-id="${current_jewelLength}"]`);
                    if ($targetsizestringLichain.length > 0) {
                      const elchin = $targetsizestringLichain[0];
                        if (elchin) {
                          elchin.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
                        }
                    }
              }

            }

              if(res[1] != 'R'){
                const $targetTypeLi = $(`.option-jewelry-type[data-name="${appState.jewelType}"] input`);
                if ($targetTypeLi.length > 0) {
                  const elType = $targetTypeLi[0];
                    if (elType) {
                      elType.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
                    }
                }
              }

        }

          //2. material
          if(res[0]){
            let current_material = 'Plated';
            if(res[0] == 'G'){
              current_material = 'Plated';
            }else if(res[0] == 'P'){
              current_material = 'Silver';
            }else if(res[0] == 'V'){
              current_material = 'Gold Vermeil';
            }else if(res[0] == 'S'){
              current_material = 'Sterling Silver';
            }else if(res[0] == 'Y'){
              current_material = '14K Gold';
            }else if(res[0] == 'W'){
              current_material = 'White';
            }
            setTimeout(() => {
              $('.option-jewelry-material[data-id="' + current_material + '"]').trigger('click');
            }, 500);
          }

          
          if(params.address){
            createBlueMarker(params.lng, params.lat);
          }
          if(appState.defPins && params.pin_lng && params.pin_lat){
            createMarkerFromUrl(params.pin_lng, params.pin_lat);
            document.marker.on('dragend', onDragEnd);
            if(params.address){
              showHideBlueMarker(params.pin_lng, params.pin_lat, 'Show');
              createBlueMarker(params.pin_lng, params.pin_lat);
            }
          }

          let current_enamel_color_4 = res[4];
          let current_enamel_color_5 = res[5];
          
          if(current_enamel_color_4 == 'B' || current_enamel_color_5 == 'B'){
            setTimeout(() => {
              $('.option-jewelry-marker-color input[type="radio"][value="Black"]').trigger('click');
            }, 500);
          }

    }

    function createMarkerFromUrl(lng, lat) {
      appState.pin_enabled = true;
      centerPearlMarker([lng, lat]);
      createRedMarker(lng, lat);
    }

    function URLToArray(url) {
      var request = {};
      var pairs = url.substring(url.indexOf('?') + 1).split('&');
      for (var i = 0; i < pairs.length; i++) {
        if (!pairs[i]) {
          continue;
        }
        var pair = pairs[i].split('=');
        request[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]).replace(/\+/g, ' ');
      }
      return request;
    }

  function generateUrlParams() {
      var params = URLToArray(appState.pageURL);
      if (appState.firstLoad == true && params.hasOwnProperty('id') == true) {
        return false;
      }

  var txtID = appState.txtMaterialID;

 // type
  var jewel_type = appState.jewelType.toLowerCase();
  if (jewel_type == 'necklace') {
    txtID += '-N';
  } else if (jewel_type == 'ring') {
    txtID += '-R';
  } else if (jewel_type == 'earrings') {
    txtID += '-E';
  } else if (jewel_type == 'cufflinks') {
    txtID += '-C';
  } else if (jewel_type == 'tie clip') {
    txtID += '-T';
  } else if (jewel_type == 'brooch' || jewel_type == 'pin') {
    txtID += '-B';
  } else {
    txtID += '-B';
  }
 // type

 // size
  var jewel_size = appState.jewelSize.toLowerCase();
    if (appState.jewelType.toLowerCase() === 'ring') {
      jewel_size = '-R';
    }
    if (jewel_size == 'large') {
      txtID += '-L';
    } else if (jewel_size == 'small') {
      txtID += '-S';
    } else if (jewel_size == 'medium') {
      txtID += '-M';
    }else{
      txtID += jewel_size;
    }

  // size

  // shape
    let selected_Shape = appState.jewelShape.toLowerCase();
    let shapeIndex = appState.jewelShape;
    
    for (let i = 0; i < CONSTANTS.SHAPE_ARRAY.length; i++) {
        if (CONSTANTS.SHAPE_ARRAY[i].toLowerCase() === selected_Shape) {
            shapeIndex = i;
            break;
        }
    }

  if (shapeIndex == 1) {
    txtID += 'S';
  } else if (shapeIndex == 2) {
    txtID += 'C';
  } else if (shapeIndex == 3) {
    txtID += 'R';
  } else if (shapeIndex == 4) {
    txtID += 'O';
  }else if (shapeIndex == 5) {
    txtID += 'P';
  }

  // shape

  if(jewel_type == 'necklace'){
    txtID += ''
  }

  // Marker/Pin
  let pin_type = appState.pinType.toLowerCase();
  if (pin_type == 'none') {
    txtID += '-N';
  } else if (pin_type == 'enamel') {
    txtID += '-E';
  } else if (pin_type == 'heart') {
    txtID += '-H';
  } else if (pin_type == 'diamond' || pin_type == 'marker') {
    txtID += '-D';
  } else {
    txtID += '-P';
  }
  // Marker/Pin

  // second variant
  if (jewel_type == 'necklace') {
      if (appState.jewelLength == 'Short' || appState.jewelLength == 'Small') {
        txtID += '-S';
      } else if (appState.jewelLength == 'Medium') {
        txtID += '-M';
      }
  } else if (jewel_type == 'ring') {
    if (shapeIndex == 4) {
      if (appState.rotateRingVal == 'TopRight') {
        txtID += '-TR';
      } else {
        txtID += '-TL';
      }
      txtID += '*' + appState.ringSizeVal;
    } else {
      txtID += '-' + appState.ringSizeVal;
    }
  }
  // second variant

  //if enamel
  if (pin_type == 'enamel') {
    let enamel_Color = appState.enamelColor?appState.enamelColor.toLowerCase(): appState.enamelColor;
    if (enamel_Color == 'black') {
      txtID += '-B';
    } else {
      txtID += '-W';
    }
  }
  //if enamel

  if ('URLSearchParams' in window) {
    var searchParams = new URLSearchParams(window.location.search);

    let variantID = $('#AddToCartForm-product input[name="id"]').val();
    searchParams.set("variant", variantID);
    searchParams.set("id", txtID);
    searchParams.set("lng", appState.map.getCenter().lng);
    searchParams.set("lat", appState.map.getCenter().lat);
    searchParams.set("zoom", appState.map.getZoom());

    let inputAddress = appState.isMobile ? $('#search-field-mobile #geocoder .mapboxgl-ctrl-geocoder--input').val() : $('#search-field-desktop #geocoder .mapboxgl-ctrl-geocoder--input').val();

    searchParams.set("address", inputAddress);

    searchParams.delete('pin_lng');
    searchParams.delete('pin_lat');

    if (appState.pin_enabled) {
      searchParams.set("pin_lng", getPinCoords()[0]);
      searchParams.set("pin_lat", getPinCoords()[1]);
    }

    searchParams.set("style_id", appState.selectedStyle);
    searchParams.set("map_view", appState.mapView);

    var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    //history.pushState(null, '', newRelativePathQuery);		
  }

  let fullMapUrl = "https://" + document.domain + newRelativePathQuery;
  console.log('MAP_JEWELRY: fullMapUrl',fullMapUrl);
  return fullMapUrl;
}

    // Step 1: Create a reusable function
    function showCopyMessage() {
      // Step 2: Create a message element
      const msg = document.createElement('div');
      msg.textContent = 'Copied to clipboard';

      // Step 3: Style it (adjust as needed)
      msg.style.position = 'fixed';
      msg.style.bottom = '60%';
      msg.style.left = '50%';
      msg.style.transform = 'translateX(-50%)';
      msg.style.background = '#333';
      msg.style.color = '#fff';
      msg.style.padding = '8px';
      msg.style.borderRadius = '4px';
      msg.style.zIndex = '9999';
      msg.style.opacity = '1';
      msg.style.transition = 'opacity 0.4s ease';

      document.body.appendChild(msg);

      // Step 4: Fade it out and remove
      setTimeout(() => {
        msg.style.opacity = '0';
        setTimeout(() => msg.remove(), 400);
      }, 1000);
    }
    
  function setCenter(center) {
    appState.map.setCenter(center);
    centerBlackMarker(center);
  }
    
    function zoomImOut(zm) {
        appState.map.flyTo({
            center: appState.map_center,
            zoom: zm,
            bearing: appState.map.getBearing()
        });
    }

    // This function capitalizes the first letter of any string
    function capitalizeFirst(str) {
        if (!str || typeof str !== 'string') {
            return str;
        }
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function colorLineItemValue(color) {
        let lowerColor = color.toLowerCase();
        switch (lowerColor) {
            case "plated":
                return "Gold";
            case "gold vermeil":
                return "Vermeil";
            case "14k gold":
                return "Yellow";
            case "silver":
                return "Palladium";
            case "sterling silver":
                return "Silver";
            case "white":
                return "White";
            default:
                return color;
        }
    }

    // function generateMapID(center){ // old function for generate map id

    //   let map_id_lng = Math.floor(Math.abs(center.lng) * 100000).toString(36).substring(0, 4);
    //   let map_id_time = Math.round((new Date).getTime() / 1000).toString(36).substr(-2);
    //   let generated_map_id = (map_id_lng + map_id_time).toUpperCase();
      
    //   if (appState.variantName === 'Statement') {
    //     generated_map_id = ((appState.jewelColor === 'Gold' || appState.jewelColor === 'Plated') ? 'G' : 'S') + generated_map_id;
    //     if (appState.jewelType === 'Necklace') {
    //       generated_map_id += appState.jewelLength === 'Short' ? '-45' : appState.jewelLength === 'Medium' ? '-50' : '';
    //     }
    //     generated_map_id = applyPinPrefix(generated_map_id);
    //   }

    //   if (appState.variantName === 'Classic') {
    //     const classicPrefixes = { Yellow: 'F14Y', White: 'F14W', Vermeil: 'FV18', Silver: 'FS' };
    //     generated_map_id = (classicPrefixes[colorLineItemValue(appState.jewelColor)] || 'FY') + generated_map_id;
    //     generated_map_id = applyPinPrefix(generated_map_id);

    //   }

    //   if (appState.jewelType === 'Ring') {
    //     generated_map_id += `(${appState.ringSizeVal})`;
    //   }

    //   return generated_map_id;
    // }

    function generateMapIDFromCombinations(center, type, shape, materiel, marker, jewelLength, ringSizeVal, enamelColor) {

          let searchType = type;
          let initial_marker = marker;
          if(marker == 'Diamond'){
              marker = 'Marker';
          }else if (marker == 'Heart') {
              marker = 'Enamel';
          }
          
          if (type !== "Cufflinks" && type !== "Brooch" && shape) {
              searchType = `${capitalizeFirst(type)} | ${capitalizeFirst(shape)}`;
          }

          const match = CONSTANTS.VARIANT_COMBINATIONS.find(combination => {
              let combinationTypeString = combination.type;
              if (combination.shape) {
                  combinationTypeString = `${combination.type} | ${combination.shape}`;
              }
              return combinationTypeString === searchType && combination.materiel === materiel && combination.marker === marker;
          });

          if (match) {
            let currentSuffix = match.suffix;
            if (type.toLowerCase() === 'necklace' && jewelLength) {
              const suffixIndex = (jewelLength.toLowerCase() === 'short') ? 0 : (jewelLength.toLowerCase() === 'medium') ? 1 : null; 
                if (suffixIndex !== null && match.suffix) {
                    currentSuffix = match.suffix.split(' / ')[suffixIndex]; 
                }
            } else if (type.toLowerCase() === 'ring' && ringSizeVal) {
                currentSuffix = '(' + ringSizeVal + ')'; 
            }

            let currentPrefix = match.prefix;
            if(initial_marker.toLowerCase() == 'heart'){
              currentPrefix = 'R-';
            }else if(initial_marker.toLowerCase() == 'enamel') {
              if(enamelColor === 'white'){
                currentPrefix = "W-";
              }else if(enamelColor == 'black'){
                  currentPrefix = "B-";
              }else{
                  currentPrefix = "R-";
              }
            }

            let current_mapid = match.mapId;
            let map_id_lng = Math.floor(Math.abs(center.lng) * 100000).toString(36).substring(0, 4);
            let map_id_time = Math.round((new Date).getTime() / 1000).toString(36).substr(-2);
            let randomNumbers = (map_id_lng + map_id_time).toUpperCase();
            let removedA = current_mapid.replace(/A+/g, "");
            let finalValuemapID = removedA + randomNumbers;

            const generatedValue = `${currentPrefix}${finalValuemapID}${currentSuffix}`;

              return generatedValue;
          } else {
              return null; 
          }
      }

    // =================================================================
    // 6. SHOPIFY & FORM LOGIC
    // =================================================================

    /**
     * Populates hidden form fields with the current customization state.
     */
function setFormVariables(map, origins=CONSTANTS.DEFAULT_MAP_ZOOM) {

    const lowerColor = appState.jewelColor ? appState.jewelColor.toLowerCase() : ''
  const statementColors = ['plated','silver'];
  if (statementColors.includes(lowerColor)) {
    appState.variantName = 'Statement';
  } else {
    appState.variantName = 'Classic';
  }

  // remove unselected variant details [hidden_properties]
  const lowerJewelType = appState.jewelType.toLowerCase()
  const allInputs = $('input.hidden_properties')
  allInputs.each(function () {
    const currentName = $(this).attr('name')
    const updatedName = currentName.replace(/^properties\[/, 'customproperties[')
    $(this).attr('name', updatedName)
  })

  const currentInput = $('input.hidden_properties.' + lowerJewelType)
  currentInput.each(function () {
    const currentName = $(this).attr('name')
    const updatedName = currentName.replace(/^customproperties\[/, 'properties[')
    $(this).attr('name', updatedName)
  })

  // remove

  let chainLengthvalue = $('input[name="customproperties[_ChainLength]"]').val();
  appState.jewelLength = 'Small';
  if (chainLengthvalue && chainLengthvalue.toLowerCase().includes('medium')) {
      appState.jewelLength = 'Medium';
  }else if (chainLengthvalue && chainLengthvalue.toLowerCase().includes('short')) {
      appState.jewelLength = 'Short';
  }

  const center = map ? map.getCenter() : { lng: CONSTANTS.DEFAULT_MAP_CENTER[0], lat: CONSTANTS.DEFAULT_MAP_CENTER[1] };

  let pinCoords = getPinCoords();
  let pin_lng = pinCoords[0];
  let pin_lat = pinCoords[1];

  // const map_id = generateMapID(center);
  let map_id = null;

  try {
    let fun_Type = appState.jewelType == 'Pin' ? 'Brooch': appState.jewelType;
    let fun_shape = appState.jewelType == 'Ring' ? appState.jewelShape : appState.jewelSize;
    let fun_material = appState.jewelColor.toLowerCase();
    let fun_marker = capitalizeFirst(appState.pinType);
    let fun_jewelLength = appState.jewelLength;
    let fun_ringSizeVal = appState.ringSizeVal;
    let fun_enamelColor = appState.enamelColor?appState.enamelColor.toLowerCase(): appState.enamelColor;

    switch (fun_material) {
      case 'plated':
        fun_material = 'Gold Plated';
        break;
      case 'silver':
        fun_material = 'Silver Plated';
        break;
      case 'sterling silver':
        fun_material = 'Sterling Silver';
        break;
      case 'gold vermeil':
        fun_material = 'Gold Vermeil';
        break;
      case '14k gold':
      case '14k yellow gold':
        fun_material = '14K Yellow Gold';
        break;
      case 'white':
      case '14k white gold':
        fun_material = '14K White Gold';
        break;
      default:
        break;
    }

    map_id = generateMapIDFromCombinations(center, fun_Type, fun_shape, fun_material, fun_marker, fun_jewelLength, fun_ringSizeVal, fun_enamelColor);
    console.log('MAP_JEWELRY: MAP ID:',map_id);
    
  } catch (error) {
    console.error('MAP_JEWELRY: NEW_MAP_ID error',error);
  }

  // Form values
  $('#my_size').val($('#overlay-left').width());
  $('#my_lng').val(center.lng);
  $('#my_lat').val(center.lat);
  $('#my_zoom').val(appState.map.getZoom());
  $('#my_bearings').val(appState.map.getBearing());
  let inputAddresss = appState.isMobile ? $('#search-field-mobile #geocoder .mapboxgl-ctrl-geocoder--input').val() : $('#search-field-desktop #geocoder .mapboxgl-ctrl-geocoder--input').val();
  $('#my_address').val(inputAddresss);
  $('#address_lat').val(appState.constLat);
  $('#address_lng').val(appState.constLng);
  $('#ts_backoffice_url').val(`https://tsbackoffice.com/tsbackoffice/finemap.php?map_id=${map_id}`);
  $('#is_swipe_map').val(true);

  $('#my_color').val(colorLineItemValue(appState.jewelColor));
    if (appState.jewelType.toLowerCase() === 'ring') {
    let newjewelSize = 'large';
    const size = appState.jewelSize.toLowerCase();
    switch (size) {
      case 'oval':
        newjewelSize = 'large';
        break;
      case 'circle':
        newjewelSize = 'small';
        break;
      case 'square':
        newjewelSize = 'small';
        break;
    }
    $('#my_jsize').val(capitalizeFirst(newjewelSize));
  } else {
    $('#my_jsize').val(capitalizeFirst(appState.jewelSize));
  }
    let selectedShape = appState.jewelShape.toLowerCase();
    let shapeIndex = appState.jewelShape;
    for (let i = 0; i < CONSTANTS.SHAPE_ARRAY.length; i++) {
        if (CONSTANTS.SHAPE_ARRAY[i].toLowerCase() === selectedShape) {
            shapeIndex = i;
            break;
        }
    }
    $('#my_jshape').val(shapeIndex);

    let my_material_fullname = appState.jewelColor;
    
    if(my_material_fullname == 'Gold' || my_material_fullname == 'Plated'){
      my_material_fullname = 'Gold Plated';
      appState.txtMaterialID = 'G';
    }else if(my_material_fullname == 'Palladium' || my_material_fullname == 'Silver'){
      my_material_fullname = 'Silver Plated';
      appState.txtMaterialID = 'P';
    }else if(my_material_fullname == 'Vermeil' || my_material_fullname == 'Gold Vermeil'){
      my_material_fullname = 'Gold Vermeil';
      appState.txtMaterialID = 'V';
    }else if(my_material_fullname == 'Silver' || my_material_fullname == 'Sterling Silver'){
      my_material_fullname = 'Sterling Silver';
      appState.txtMaterialID = 'S';
    }else if(my_material_fullname == 'Yellow' || my_material_fullname == '14K Gold'){
      my_material_fullname = '14k Yellow Gold';
      appState.txtMaterialID = 'Y';
    }else if(my_material_fullname == 'White'){
      my_material_fullname = '14K White Gold';
      appState.txtMaterialID = 'W';
    }

  $('#my_material_fullname').val(my_material_fullname);

  if(appState.jewelType.toLowerCase() == 'necklace'){
    let chainsizeLengthvalue = $('input[name="customproperties[_ChainLength]"]').val();
    $('#necklace_chain_size').val(chainsizeLengthvalue);
  }else{
    $('#necklace_chain_size').val('');
  }

  $('#my_material').val(colorLineItemValue(appState.jewelColor));
  $('#my_type').val(appState.jewelType);
  if (appState.pinType) {
    $('#my_pin_type').val(appState.pinType.charAt(0).toUpperCase() + appState.pinType.slice(1));
  } else {
    $('#my_pin_type').val(appState.pinType);
  }

  if(appState.pinType != 'None'){
    jQuery("#my_pin_lng").val(getPinCoords()[0]);
    jQuery("#my_pin_lat").val(getPinCoords()[1]);
  }else{
    jQuery("#my_pin_lng").val('');
    jQuery("#my_pin_lat").val('');
  }

  $('#my_jshape_str').val(CONSTANTS.SHAPE_ARRAY[appState.jewelShape]);
  $('#my_chain_type').val(appState.NecklaceSecVar);
  $('#my_ring_size').val(appState.ringSize);
  $('#my_earring_type').val(appState.earringsSecVar);

  // Descriptions
  let fullTxt = `Color:${colorLineItemValue(appState.jewelColor)}, Size:${capitalizeFirst(appState.jewelSize)}, Shape:${CONSTANTS.SHAPE_ARRAY[appState.jewelShape]}, Type:${appState.jewelType}, RingDir:${appState.rotateRingVal}, PinType:${appState.pinType}, PinLat:${pin_lat}, PinLon:${pin_lng}`;
  $('#my_all_vars').val(fullTxt);

  let isThisGoldTone = appState.jewelColor ? ['Gold', 'Vermeil', 'Yellow', 'Plated'].some(tone => appState.jewelColor.includes(tone)) : false;

  let my_static_style = isThisGoldTone ? CONSTANTS.STATIC_STYLE_GOLDEN[appState.selectedStyle] : CONSTANTS.STATIC_STYLE_SILVER[appState.selectedStyle];

  let everyTxt = [
    `Lat:${center.lat}`, `Lon:${center.lng}`,
    `Zoom:${appState.map.getZoom()}`, `Bearing:${appState.map.getBearing()}`,
    `AddressLat:${appState.constLat}`, `AddressLon:${appState.constLng}`,
    `Color:${colorLineItemValue(appState.jewelColor)}`, `Size:${capitalizeFirst(appState.jewelSize)}`,
    `Shape:${CONSTANTS.SHAPE_ARRAY[appState.jewelShape]}`, `Type:${appState.jewelType}`,
    `EarringChoice:${appState.earringChoice}`, `RingDir:${appState.rotateRingVal}`,
    `PinType:${appState.pinType}`, `PinLat:${pin_lat}`, `PinLon:${pin_lng}`,
    `LayerName:${CONSTANTS.STYLE_NAMES[appState.selectedStyle]}`, `LayerID:${appState.selectedStyle}`,
    `StaticMapID:${my_static_style}`, `enamelColor:${appState.enamelColor}`,
    `NecklaceVar:${appState.NecklaceSecVar}`, `RingSize:${appState.ringSize}`, `EarringsVar:${appState.earringsSecVar}`
  ].join(', ');
  $('#my_every_vars').val(everyTxt);

  $('#my_layer_name').val(CONSTANTS.STYLE_NAMES[appState.selectedStyle]);
  $('#my_layer_id').val(appState.selectedStyle);
  $('#my_static_map_id').val(my_static_style);

  $('#my_ring_direction').val(appState.jewelType.toLowerCase() === 'ring' && appState.jewelShape.toLowerCase() == 'oval' ? appState.rotateRingVal : 'N/A');

  let finalValue = appState.jewelType.toLowerCase() == 'necklace' ? appState.jewelLength : 'N/A';
  $('#my_length').val(finalValue);
  
  $('#my_earring_choice').val(appState.jewelType === 'Earrings' ? appState.earringChoice : 'N/A');
  if (appState.jewelType !== 'Earrings') $('#my_earring_type').val('N/A');
  if (appState.jewelType !== 'Ring') $('#my_ring_size').val('N/A');
  if (appState.jewelType !== 'Necklace') $('#my_chain_type').val('N/A');

  $('#my_enamel_color').val((appState.pinType === 'Heart' || appState.pinType === 'heart') ? 'Red' :appState.pinType === 'Enamel' ? appState.enamelColor : 'N/A');

  $('#my_variant_name').val(appState.variantName);
  $('#map_id').val(map_id);

  if (center.lng !== CONSTANTS.DEFAULT_MAP_CENTER[0] && center.lat !== CONSTANTS.DEFAULT_MAP_CENTER[1]) {
    $('.map-error').remove();
  }

  $('#jewelry-preview-btn').attr('data-mapid', map_id);

}

function updateVariantPrices(variant = null, onLoad = true) {
  const mCols = appState.jewelType === "Tie Clip" ? "TieClip" : appState.jewelType;
  const discount = CONSTANTS.VARIANT_DISCOUNT[mCols]?.[appState.jewelColor] || CONSTANTS.VARIANT_DISCOUNT[mCols]?.[appState.jewelColor.toLowerCase()] || 0;
  let compPrice = 0;
  if (!onLoad) {
    compPrice = variant ? (parseInt(variant.price, 10) || 0) : 0;
  } else {
    compPrice = parseInt($("#current_variantPrice").attr("data-item-base-price"), 10) || 0;
  }

  // Calculate base price after discount
  const discountedPrice = Math.round(compPrice - (compPrice * discount) / 100);
  const savings = compPrice - discountedPrice;

  // DOM elements (cached for reuse)
  const $disAmt_wrap = $(".save-price-left");
  const $savepriceright = $(".save-price-right");

  const $disAmt = $(".save-price-dis-amt");
  const $org = $(".save-price-org");
  const $com = $(".save-price-com");
  const $leftSaveDiv = $('.save-price-left div');

  if(savings > 0){
    $disAmt_wrap.show();
  }else{
    $disAmt_wrap.hide();
  }

  if (discountedPrice !== compPrice) {
    $com.show();
    $savepriceright.removeAttr('style');
  } else {
    $com.hide();
    $savepriceright.css({
      width: '100%',
      justifyContent: 'center'
    });
  }


  // Update DOM with formatted prices
  $disAmt.html(`$${(savings / 100).toFixed(2)}`);
  $org.html(`$${(discountedPrice / 100).toFixed(2)}`);
  $com.html(`$${(compPrice / 100).toFixed(2)}`);
}

// helper functions
function applyPinPrefix(id) {
  const pinType = String(appState.pinType || 'None').toLowerCase();
  const enamelColor = String(appState.enamelColor || 'Black').toLowerCase();
  switch (pinType) {
    case 'pearl':
      return 'P-' + id;
    case 'enamel':
      return (enamelColor === 'white' ? 'W-' : enamelColor === 'black' ? 'B-' : '') + id;
    case 'heart':
      return 'R-' + id;
    case 'diamond':
    case 'marker':
    case 'marker diamond':
      return 'D-' + id;
    default:
      return id;
  }
}

    // =================================================================
    // 8. EVENT LISTENERS
    // Using event delegation for better performance.
    // =================================================================

  // Move main slider
  var indexOfElem = 0;
  let slidePos = 0;
  function moveSlider(direction) {
      if (appState.isMobile) {
      const winHeight = $('.bottom-slide-mobile').height();
      const scrollLeft = $('.slide-inner-div').scrollLeft();
      const step = (winHeight + 1) * 2;

      $('.slide-inner-div').animate(
          { scrollLeft: scrollLeft + (direction === 'right' ? step : -step) },
          250
      );
      return;
      }

      const slideWidth = $('.scrollable-slide').width();
      const winWidth = $(window).width();
      const extra = (slideWidth - winWidth) * -1;

      if (appState.isMobile) {
      var mediaWidth = parseInt($('.scrollable-slide').data('mobilewidth')) || 300;
      }else{
      var mediaWidth = parseInt($('.scrollable-slide').data('width')) || 300;
      }

      slidePos += direction === 'right' ? -(mediaWidth) : (mediaWidth);
      if (slidePos < extra) {
        slidePos = extra;
        $('.rightSlide').hide();
      } else if (slidePos >= 0) {
        slidePos = 0;
        $('.leftSlide').hide();
      } else {
        $('.leftSlide, .rightSlide').show();
      }
      $('.scrollable-slide').css({ transform: `translateX(${slidePos}px)` });
  }

  // Navigate popup slides
  function movePopup(direction) {
      const len = $('.show-slide').length;
      indexOfElem += direction === 'right' ? 1 : -1;
      if (indexOfElem >= len) indexOfElem = 0;
      if (indexOfElem < 0) indexOfElem = len - 1;
      const img = $('.show-slide').eq(indexOfElem).find('img').attr('src');
      $('.popUpImgSrc').attr('src', img);
  }

  // Close popup
  function closePopup() {
      $('.myPopUpOuterS').hide();
  }

// ================== View Toggle Module ==================
  let timeout = 0;
  let startX = 0;
  const $previewBtn = $('#jewelry-preview-btn');
  const $mapBtn = $('#map-view-btn');

  function getCurrSwiperX() {
    return $('.mapboxgl-compare').css('transform').split(/[()]/)[1].split(',')[4].trim();
  }

  async function changeSwiperPositionDelayed(map, x) {
    setTimeout(() => { map._setPosition(x); }, timeout);
  }

  function selectView(view) {
    if (view === 'preview') {
      $previewBtn.addClass('selected');
      $mapBtn.removeClass('selected');
      timeout = 0;
      startX = getCurrSwiperX();
      for (i = startX; i >= 0; i--) {
        changeSwiperPositionDelayed(compareMap, i, timeout);
        timeout += 1;
      }
      appState.mapView = 1;
    } else if (view === 'map') {
        $mapBtn.addClass('selected');
        $previewBtn.removeClass('selected');
        $('.flip_icon').hide();
        timeout = 0;
        startX = getCurrSwiperX();
        const mapContainer = document.getElementById('map-compare-container');
        const actualWidth = mapContainer.offsetWidth;
        // for (i = startX; i <= startX; i++) {
        for (i = startX; i <= actualWidth; i++) {
          changeSwiperPositionDelayed(compareMap, i, timeout)
          timeout += 1;
        }
        appState.mapView = 0;
    }
    rotateRing(appState.rotateRingVal);
  }
  

    function positionRedMarker() {

  var lngLat = document.marker.getLngLat();
  let lng = lngLat.lng;
  let lat = lngLat.lat;

    appState.geojson = {
      "type": "FeatureCollection",
      "features": [{
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": [lng, lat]
        }
      }]
    };
    appState.map.getSource('point').setData(appState.geojson);
    appState.map.setLayoutProperty('point', 'visibility', 'visible');

  }

function onDragEnd() {
  var lngLat = document.marker.getLngLat();
  let pinLngs = lngLat.lng;
  let pinLats = lngLat.lat;

  appState.map.removeLayer('point');
  appState.map.removeSource('point');

  appState.geojson = {
    "type": "FeatureCollection",
    "features": [{
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [pinLngs, pinLats]
      }
    }]
  };

  appState.map.addSource('point', {
    "type": "geojson",
    "data": appState.geojson
  });

  appState.map.addLayer({
    "id": "point",
    "type": "circle",
    "source": "point",
    "paint": {
      "circle-radius": 10,
      "circle-color": "#C1272D"
    }
  });
  setFormVariables(appState.map, 15);
}

  function handleCompareMove() {
    const currX = getCurrSwiperX();
    if (currX < 0.5 * appState.mapWidth) {
      selectView('preview');
    } else {
      selectView('map');
    }
    document.marker.on('dragend', onDragEnd);

  }

  // ================== Event Bindings ==================
  $previewBtn.on('click', () => selectView('preview'));
  $mapBtn.on('click', () => selectView('map'));
  $('.mapboxgl-compare').on('mouseup touchend touchstart', handleCompareMove);

    function initializeEventListeners() {
        const $document = $(document);

        // Jewelry Type Selection
        $document.on('click', '.option-jewelry-type', function () {
            try {
                handleJewelryTypeChange(this);
            } catch (error) {
                console.error("MAP_JEWELRY: Error changing jewelry type:", error);
            }
        });

        $document.on('click', '.option-jewelry-type-jewelshape', function () {
          $(this).closest('.map-option-section').find('input').removeClass('checked');
          $(this).find('input').addClass('checked');
          appState.jewelShape = $(this).find('input').val() || 'Circle';
          if (appState.jewelShape) {
            $('.Jewelry_map_product').attr('data-selectedshape', appState.jewelShape.toLowerCase());
          }
          $(`span[data-shapelabel="true"]`).text(appState.jewelShape);
          updateAll();
        });

        // Material Selection
        $document.on('click', 'span.option-jewelry-material', function (e) {
            try {
                handleMaterialChange(this);
            } catch (error) {
                console.error("MAP_JEWELRY: Error changing material:", error);
            }
        });

        $document.on('click', '#AddToCart-product', function (e) {
          e.preventDefault();
          var $loader = $(this).find('.loader');
          if ($loader.length > 0) {
            $(this).find('span').addClass('hidden');
            $loader.removeClass('hidden');
          }
        });

        // Shape & Size Selection
        $document.on('click', '.option-jewelry-type-shape', function () {
             try {
                appState.jewelSize = $(this).data('size');

                $('.flip_icon').hide();
                if (appState.jewelSize?.toLowerCase() === 'oval' && appState.jewelType?.toLowerCase() === 'ring') {
                  // $('.flip_icon').show();
                }
                
                if($(this).data('shape') == 'Ring'){
                  appState.jewelShape = $(this).data('size');
                  $('.Jewelry_map_product').attr('data-selectedshape', appState.jewelShape.toLowerCase());
                }
                $('.marker-jewelry-type-ring-shape-strings').hide();
                 if (appState.jewelType.toLowerCase() == 'ring') {
                  $('.marker-jewelry-type-ring-shape-strings[data-lshape="' + appState.jewelSize.toLowerCase() + '"]').show();
                }
                setTimeout(() => {
                let labelValue = '';
                if (appState.jewelType.toLowerCase() == 'ring') {
                  labelValue = appState.jewelSize + ' (' + $('.jewel_ring_size_input').val() + ')';
                } else {
                  labelValue = appState.jewelShape;
                }

                $(`span[data-shapelabel="true"]`).text(labelValue);
                }, 111);
                updateAll();
            } catch (error) {
                console.error("MAP_JEWELRY: Error changing shape/size:", error);
            }
        });

        // option-jewelry-select-type-ChainLength
       $document.on('click', '.option-jewelry-select-type-ChainLength ul li', function (e) {
          updateAll();
        });

        // option-jewelry-select-type-ChainSize
       $document.on('click', '.option-jewelry-select-type-ChainSize ul li', function (e) {
        // get clicked size
        let currentThis = $(this);
        let aThisSize = $(this).find('a').data('size'); 
        let aThisChange = $(this).find('a').data('change'); 
        let parentVariant = $(this).closest('.option-jewelry-select-type-ChainSize').data('variant');

        if(parentVariant && parentVariant.toLowerCase() == 'ring'){
          let selected_ring_size = currentThis.text();
          appState.ringSize = selected_ring_size;
          let number = parseFloat(selected_ring_size.match(/[\d.]+/)[0]);
          appState.ringSizeVal = number;

          setTimeout(() => {
            let labelValue = appState.jewelSize + ' (' + $('.jewel_ring_size_input').val() + ')';
            $(`span[data-shapelabel="true"]`).text(labelValue);
          }, 111);

          updateAll();
        }

        if(aThisChange && aThisSize){
          let currentSize = aThisSize.toLowerCase();
          appState.jewelSize = currentSize === 'small' && (parentVariant.toLowerCase() === 'brooch' || parentVariant.toLowerCase() === 'pin') ? 'medium': currentSize;
          updateAll();
        }

        var dSize = $(`.option-jewelry-type-shape input[type="radio"]`).closest(`[data-shape="${parentVariant}"]`);
        dSize.each(function () {
          let $el = $(this); // current element
          let sizeVal = $el.data('size'); // read data-size
          if(!sizeVal){
            return;
          }
          if (sizeVal == aThisSize || String(sizeVal).toLowerCase() == String(aThisSize).toLowerCase()) {
            $el.find('input[type="radio"]').trigger('click');
          }
        });

        handleMaterialChange($('.option-jewelry-material input[type="radio"].checked').closest('[data-id]') || $('.option-jewelry-material input[type="radio"]:checked').closest('[data-id]'),false);

      });

        // marker 
      $document.on('click', '.option-jewelry-marker', function () {
        var $this= this;

        var lastPin = appState.pinType;
        var pinType = $(this).attr('data-id');
        $($this).closest('fieldset').find('[custom-data-option-value]').text(pinType);

        if(pinType == 'Marker' || pinType == 'Diamond'){
          appState.pinType = 'Diamond';
        }else{
          appState.pinType = pinType;
        }

        $(this).closest('.map-option-section').find('input').removeClass('checked');
        $(this).find('input').addClass('checked');

        var markerType = $(this).attr('data-type') ? $(this).attr('data-type').toLowerCase() : '';

        $('.map-jewelry-marker-color-option').hide();
        $('.map-jewelry-marker-color-option[data-variant="' + markerType + '"]').show();

        appState.enamelColor = 'White';
        $('.option-jewelry-marker-color-swatch input[type="radio"][value="White"]').prop('checked', true).trigger('click');

        if(appState.pinType == 'Heart' || appState.pinType == 'heart'){
            const enamelRadio = $('.option-jewelry-marker[data-id="Enamel"] input[type="radio"]');
            enamelRadio.prop('checked', true);
            enamelRadio.trigger('change');
            const enamelRadioEl = enamelRadio[0];
            enamelRadioEl.dispatchEvent(new MouseEvent('change', { bubbles: true, cancelable: true }));
        }

        $('.map-jewelry-marker-color-option[data-variant="' + markerType + '"] input[type="radio"][value="white"]').prop('checked', true).trigger('change');
        updateAll();

        // debouncedUpdateAll();

        showHideMarker(appState.map.getCenter().lng, appState.map.getCenter().lat, lastPin, true);

        document.marker.on('dragend', onDragEnd);
      });

        // marker color option 
      $document.on('click', '.option-jewelry-marker-color', function () {
        $(this).closest('.map-option-section').find('input').removeClass('checked');
        $(this).find('input').addClass('checked');
        appState.enamelColor = $(this).find('input').val() || 'White';
        updateAll();
      });

      // Accordion Toggle
      $document.on('click', '.accord-top', function () {
          $(this).parent().find('.accord-bot').slideToggle(200);
      });
    
      // Click outside to close elements
      $document.on('mouseup', function(e) {
      
              // Close guide popup
          const $guide_popup = $('.jewelry-guide-area');
          const $guide_popup_inr = $('.jewelry-guide-area-inr');
          if (!$guide_popup_inr.is(e.target) && $guide_popup_inr.has(e.target).length === 0) {
                $guide_popup.hide();
                $('body').removeClass('guide-open');
          }
          
          // Close slideshow popup
          const $popup = $('.myPopUpOuterS');
          if (!$popup.find('.myPopUpInnerS').is(e.target) && $popup.find('.myPopUpInnerS').has(e.target).length === 0) {
                $popup.hide();
          }
      });

      $document.on('click', '.slide-imgs', function () {
          indexOfElem = $('.slide-imgs').index(this);
          var img = $(this).find('img').attr('src');
          $('.popUpImgSrc').attr('src', img);
          $('.myPopUpOuterS').show();
      });

            // ================== Event Bindings ==================
            $document.on('click', '.rightSlide', () => moveSlider('right'));
            $document.on('click', '.leftSlide', () => moveSlider('left'));
            $document.on('click', '.rightSlidePop', () => movePopup('right'));
            $document.on('click', '.leftSlidePop', () => movePopup('left'));
            $document.on('click', '.popSlideClose', closePopup);

            $document.on('click', '.close-size-guide', function () {
              $('.jewelry-guide-area').hide();
              $('body').removeClass('guide-open');
            });

            $document.on('click', '.flip_icon', function () {
              const $this = $(this);
              const isFlippedzero = parseInt($this.attr('data-id') ?? 0, 10) === 1;
              $this.attr('data-id', isFlippedzero ? '0' : '1');
              const isFlipped = appState.rotateRingVal === 'TopLeft';
              appState.rotateRingVal = isFlipped ? 'TopRight' : 'TopLeft';
              rotateRing(appState.rotateRingVal);

              setFormVariables(appState.map,13);
            });

            $document.on('click', '.map-option-top', function () {             
              if(appState.mapView == 0){
                selectView('preview');
              }
            });

            // jewelry-guide-link
            $document.on('click', '.jewelry-guide-link', function () {
              let targetId = $(this).data('guide-target');
              $('body').addClass('guide-open');
              $('.jewelry-guide-area').hide();
              $('.jewelry-guide-area[data-id="' + targetId + '"]').show();
            });

              let zoomSensitivity = CONSTANTS.MAP_VARS.map_zoominClickLeves || 1;
              const multiplier = 0.2; // adjust multiplier if needed

              // Listen for zoom-in click
              $document.on('click', '.zoom-in', function () {
                const currentZoom = appState.map.getZoom();
                const zoomStep = zoomSensitivity * multiplier; 
                zoomImOut(currentZoom + zoomStep);
              });

              // Listen for zoom-out click
              $document.on('click', '.zoom-out', function () {
                const currentZoom = appState.map.getZoom();
                const zoomStep = zoomSensitivity * multiplier;
                zoomImOut(currentZoom - zoomStep);
              });

            $document.on('click', '.mobile-menu', function () {
                if ($(this).hasClass('menu-close')) {
                    $(this).removeClass('menu-close');
                    $('.custom_map_styles').hide();
                } else {
                    $(this).addClass('menu-close');
                    $('.custom_map_styles').show();
                }
            });

            $document.mouseup(function (e) {
                if ($(".mobile-menu").is(e.target)) {
                    return;
                }
                var container = $(".custom_map_styles");
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    container.hide();
                    $('.mobile-menu').removeClass('menu-close');
                }
            });

            $document.on('click', '.h1Prvs', function () {
                $('.h1Prvs').removeClass('h1PrvsSel');
                $(this).addClass('h1PrvsSel');
                $('.mobile-menu').removeClass('menu-close');
                $('.custom_map_styles').hide();
                appState.selectedStyle = $(this).attr('data-name');
                updateMapLayers();
                setFormVariables(appState.map, 16);
                // $('#jewelry-preview-btn').trigger('click');
            });

            $document.on('click', '.copygenurl', function (e) {
              e.preventDefault();

              var textToCopy = generateUrlParams();

              copyToClip(textToCopy).then(function (result) {
                if (result) {
                  showCopyMessage();
                }
              });
            });

    }

      function moveGeocoder() {
        var $mobileContainer = $('#search-field-mobile .map-option-input-outer');
        var $desktopContainer = $('#search-field-desktop .map-option-input-outer');
        var $geocodercontainer = $('.geocoder-search-container'); // grab the geocoder element
        if ((/Mobi|Android|iPhone|iPod/i.test(navigator.userAgent) || navigator.userAgentData?.mobile) && window.innerWidth < 925) {
          $geocodercontainer.detach().appendTo($mobileContainer);
        } else {
          $geocodercontainer.detach().appendTo($desktopContainer);
        }
      }

    // Run again when window is resized
    $(window).on('resize', function () {
        if(appState.mapView == 1){
          selectView('preview');
        }else{
          selectView('map');
        }
    });

    function preLoadImages() {
        //Necklace - Gold
        new Image().src = 'https://taliasari.com/cdn/shop/files/S_circle_necklace_gold_80px.svg?v=1761216506';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_M_circle_necklace_gold_115px.svg?v=1761216507';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_square_necklace_115px_gold.svg?v=1761218567';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_square_necklace_80px_gold.svg?v=1761218568';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_Pear_necklace_gold.svg?v=1761217388';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_Pear_necklace_gold.svg?v=1761217389';

        //Necklace - Silver
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_Pear_necklace_silver.svg?v=1761217389';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_Pear_necklace_silver.svg?v=1761217389';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_square_necklace_80px_silver.svg?v=1761218569';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_square_necklace_115px_silver.svg?v=1761218568';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_M_circle_necklace_silver.svg?v=1761216507';
        new Image().src = 'https://taliasari.com/cdn/shop/files/S_circle_necklace_silver_80px.svg?v=1761216507';

        //Earrings - Gold
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_circle_earrings_GOLD.svg?v=1761223065';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_circle_earrings_GOLD.svg?v=1761223066';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_square_earrings_115px_GOLD.svg?v=1761292547';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_square_earrings_80px_GOLD.svg?v=1761292547';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_Pear_earrings_GOLD.svg?v=1761291823';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_Pear_earrings_GOLD.svg?v=1761291823';

        //Earrings - Silver
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_Pear_earrings_SILVER.svg?v=1761291823';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_Pear_earrings_SILVER.svg?v=1761291822';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_square_earrings_80px_SILVER.svg?v=1761292546';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_square_earrings_115px_SILVER.svg?v=1761292547';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_circle_earrings_SILVER.svg?v=1761223066';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_circle_earrings_SILVER.svg?v=1761223066';

        //Ring - Gold
        new Image().src = 'https://taliasari.com/cdn/shop/files/Ring_Circle_Gold.svg?v=1761219081';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Ring_Square_Gold.svg?v=1761219082';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Oval_Ring_Gold.svg?v=1761219081';

        //Ring - Silver
        new Image().src = 'https://taliasari.com/cdn/shop/files/Oval_Ring_Silver.svg?v=1761219081';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Ring_Square_Silver.svg?v=1761219081';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Ring_Circle_Silver.svg?v=1761219081';

        //Pin/Brooch - Gold
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_circle_brooch_115px_GOLD.svg?v=1761293748';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_square_brooch_115px_GOLD.svg?v=1761293748';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_Pear_brooch_gold.svg?v=1761293748';

        //Pin/Brooch - Silver
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_Pear_brooch_silver.svg?v=1761293748';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_square_brooch_115px_SILVER.svg?v=1761293747';
        new Image().src = 'https://taliasari.com/cdn/shop/files/22_Medium_circle_brooch_115px_SILVER.svg?v=1761293748';

        //Cufflinks - Gold
        new Image().src = 'https://taliasari.com/cdn/shop/files/Samll_circle_cufflink_GOLD.svg?v=1761293121';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_square_cufflink_GOLD.svg?v=1761293312';

        //Cufflinks - Silver
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_square_cufflink_SILVER.svg?v=1761293313';
        new Image().src = 'https://taliasari.com/cdn/shop/files/Small_circle_cufflink_SILVER.svg?v=1761293120';

      }

    // =================================================================
    // 9. INITIALIZATION
    // Main function to kick things off.
    // =================================================================

    function init() {
        console.log("MAP_JEWELRY: 🚀🚀🚀 Jewelry Customizer Initializing...");

        (function () {
          let lastClickedElement = null;
          // Step: Track last clicked element
           document.addEventListener('pointerdown', function (e) {
            lastClickedElement = e.target;
          });

          const originalFetch = window.fetch;

          window.fetch = function (...args) {
            const url = args[0];

            if (typeof url === 'string' && url.includes('/cart/add.js')) {
              if (lastClickedElement && lastClickedElement.closest('.quickview__form')) {
                  return originalFetch.apply(this, args);
                }
              console.warn('MAP_JEWELRY: Fetch blocked for add-to-cart');
              return Promise.reject('Blocked');
            }

            return originalFetch.apply(this, args);
          };
        })();
        
        // Detect mobile early
        $('body').toggleClass('is-mobile', appState.isMobile);

        // Run on page load
        try {
          // moveGeocoder();

          const geocoderElement = document.getElementById('geocoder');
          const mapContainer = document.getElementById('map-compare-container');
          if (geocoderElement && mapContainer) {
            const updateWidth = () => {
              const isMobile = ((/Mobi|Android|iPhone|iPod/i.test(navigator.userAgent) || navigator.userAgentData?.mobile) && window.innerWidth < 925);
              const shouldApplyMinWidth = isMobile && window.innerWidth < 925;
              if (shouldApplyMinWidth) {
                mapContainer.style.minWidth = geocoderElement.offsetWidth + 'px';
              } else {
                mapContainer.style.minWidth = ''; // remove inline min-width
              }
            };
            updateWidth();
            new ResizeObserver(updateWidth).observe(geocoderElement);
            window.addEventListener('resize', updateWidth);
          }

        } catch (error) {
          console.warn('MAP_JEWELRY: ERROR in moveGeocoder field:', error);
        }

        try {
          initializeMaps();
        } catch (error) {
          console.warn('MAP_JEWELRY: ERROR in initializeMaps:', error);
        }

        try {
          initializeEventListeners();
        } catch (error) {
          console.warn('MAP_JEWELRY: ERROR in initializeEventListeners:', error);
        }

        try {
          updateAll();
        } catch (error) {
          console.warn('MAP_JEWELRY: ERROR in updateAll:', error);
        }

        try {
         updateVariantPrices(null, true);
        } catch (error) {
         console.warn('MAP_JEWELRY: ERROR in update price:', error);
        }

        var myPopUpHTML = '<div class="myPopUpOuterS">';
        myPopUpHTML += '<div class="myPopUpInnerS">';
        myPopUpHTML += '<div class="myPOpUpImgCont"><img src="/" class="popUpImgSrc"></div>';
        myPopUpHTML += '<div class="poparr leftSlidePop"> <div class="in-arr"></div> </div>';
        myPopUpHTML += '<div class="poparr rightSlidePop"> <div class="in-arr"></div> </div>';
        myPopUpHTML += '<div class="popSlideClose"></div>';
        myPopUpHTML += '</div>';
        myPopUpHTML += '</div>';

        $('body').append(myPopUpHTML);
        
        appState.firstLoad = false;
        console.log("MAP_JEWELRY: ✅✅✅ Initialization Complete.");

        try {
         preLoadImages();
        } catch (error) {
         console.warn('MAP_JEWELRY: ERROR in preLoad Images:', error);
        }

      document.addEventListener("priceUpdatedEvent", function (e) {
        updateVariantPrices(e.detail.variant, false);
        //  var url = new URL(window.location.href);
        // if (url.searchParams.has('variant')) {
        //   url.searchParams.delete('variant');
        //   history.replaceState({}, '', url.toString());
        // }
      });

      document.addEventListener("unavailableVariantEvent", function (e) {
        const element = e.detail.element;
        $(element.target).closest('.selector-wrapper[data-select-label="Type"]').find('span[data-option-value]').text(appState.jewelType);
      });
    }

    // Run the initializer
    init();
});